// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  adhocIdentityCheckDigital,
  authAcceptInviteExistingUser,
  authAcceptInviteNewUser,
  authCheckInvite,
  authSignup,
  checkdAddressValidate,
  checkdAutoEftDashboard,
  checkdDashboardMetrics,
  eftAutoPaymentList,
  fileUploadIntent,
  fileView,
  getFeatureFlags,
  getHealth,
  getLookupTableValues,
  getSelfAppData,
  iduAuditList,
  iduAutoEftMerchantWarriorCheck,
  iduAutoEftMetrics,
  iduAutoEftRecords,
  iduAutoEftResolutionRecord,
  iduAutoEftRetryable,
  iduBndryAlertHistory,
  iduCheckdVenueSettingGet,
  iduCheckdVenueSettingUpdate,
  iduDashboardCheckdMetrics,
  iduDashboardCheckdPayoutList,
  iduDashboardCheckdVenueMetrics,
  iduDashboardCheckdVenueTables,
  iduDashboardMetrics,
  iduDashboardUserAdd,
  iduDashboardUsersList,
  iduInAppMessageCreate,
  iduInAppMessageDelete,
  iduInAppMessageGet,
  iduInAppMessageList,
  iduInAppMessageUpdate,
  iduInviteAvailability,
  iduInviteList,
  iduInviteManualAccept,
  iduInviteResend,
  iduInviteRevoke,
  iduInviteSkipAndAdd,
  iduKycDashboard,
  iduLogsList,
  iduNightlifeVenueLink,
  iduNightlifeVenueLinkTo,
  iduNightlifeVenueList,
  iduNightlifeVenueRelink,
  iduPayoutAudit,
  iduPayoutCorrection,
  iduPayoutCorrectionPreview,
  iduPayoutDetail,
  iduPayoutVenueMove,
  iduPayoutVenueMovePreview,
  iduPepCheckActivityList,
  iduPepCheckRunStats,
  iduSettingsGet,
  iduSettingsUpdate,
  iduUserAssignToVenue,
  iduUserCreate,
  iduUserEmailSearch,
  iduUserGet,
  iduUserInviteCreate,
  iduUserList,
  iduUserPasswordChange,
  iduUserRemoveFromVenue,
  iduUserResetPassword,
  iduUserSearch,
  iduUserTwoStep,
  iduUserTwoStepCode,
  iduUserTwoStepReset,
  iduUserTwoStepUpdate,
  iduUserUpdate,
  iduVenueApplicationAssign,
  iduVenueApplicationRemove,
  iduVenueCreate,
  iduVenueGet,
  iduVenueList,
  iduVenueMwCredentialsStatus,
  iduVenueMwCredentialsUpdate,
  iduVenueNightlifeCreate,
  iduVenueNightlifeLegacyManagers,
  iduVenueNightlifeLinks,
  iduVenueNightlifeSettingsGet,
  iduVenueNightlifeSettingsUpdate,
  iduVenueRolesList,
  iduVenueUpdate,
  iduVenueUsersList,
  inAppMessageMarkRead,
  inAppMessageUnreadForApplicationList,
  internalNightlifeGrantCreate,
  logCreate,
  nightlifeManagerInvite,
  nightlifeManagerInviteResend,
  nightlifeManagerInviteRevoke,
  nightlifeManagerList,
  nightlifeManagerRemove,
  oauthProvision,
  type Options,
  patronAuditTrail,
  patronCaptureAdd,
  patronCaptureCompare,
  patronCreate,
  patronDetailsUpdate,
  patronDvsCheckRun,
  patronGet,
  patronIdentityCheckAttach,
  patronIdentityCheckDigital,
  patronList,
  patronPepCheckDecide,
  patronPepCheckRun,
  patronSearch,
  patronTypeUpdate,
  payoutAuditTrail,
  payoutConfirmationOfPayeeNotesUpdate,
  payoutConfirmationOfPayeeReVerify,
  payoutConfirmationOfPayeeVerify,
  payoutConnectIdShortLink,
  payoutConnectIdVerificationCancel,
  payoutConnectIdVerificationStart,
  payoutConnectIdVerificationStatus,
  payoutCreate,
  payoutDiscard,
  payoutGet,
  payoutIdentityCheckDigital,
  payoutList,
  payoutManagerElevationRefresh,
  payoutManagerReviewGet,
  payoutManagerReviewPost,
  payoutPhase1PatronId,
  payoutPhase2Ticket,
  payoutPhase3Kyc,
  payoutPhase3KycVerify,
  payoutPhase4ContactPayment,
  payoutPhase5PatronSignOff,
  payoutPhase6AttendantSignOff,
  payoutPhase7ManagerSignOff,
  payoutPhase8Payout,
  payoutReceiptSend,
  payoutUpdate,
  payoutView,
  permissionCatalogueList,
  pokieVenueSettingGet,
  pokieVenueSettingRiskRuleList,
  pokieVenueSettingUpdate,
  ppUserInvite,
  ppUserReinvite,
  ppUserRevokeInvite,
  ppVenueUserCreate,
  ppVenueUserDelete,
  ppVenueUserGet,
  ppVenueUserList,
  ppVenueUserUpdate,
  resetPassword,
  riskRegisterAttachmentCreate,
  riskRegisterAttachmentDelete,
  riskRegisterAttachmentGet,
  riskRegisterCreate,
  riskRegisterList,
  riskRegisterMetrics,
  riskRegisterPatronSearch,
  riskRegisterPayoutSearch,
  riskRegisterReview,
  scanLicense,
  selfProfileGet,
  selfProfileUpdate,
  staffAccess,
  twoStepConfirmMethod,
  twoStepForgetAllDevices,
  twoStepForgetDevice,
  twoStepListDevices,
  twoStepRemoveMethod,
  twoStepRequire,
  twoStepSendCode,
  twoStepSetChoice,
  twoStepSetPreferred,
  twoStepStartAuthenticator,
  twoStepStartSms,
  twoStepStatus,
  twoStepVerify,
  twoStepVerifyDevice,
  userGetData,
  userPinCheck,
  userPublicProfile,
  userUpdateProfile,
  venueAssignableRoleList,
  venueRoleCreate,
  venueRoleDelete,
  venueRoleGet,
  venueRoleList,
  venueRolePermissionsUpdate,
  venueRoleUpdate,
  voiSettingGet,
  voiSettingUpdate,
} from '../sdk.gen';
import type {
  AdhocIdentityCheckDigitalData,
  AdhocIdentityCheckDigitalError,
  AdhocIdentityCheckDigitalResponse,
  AuthAcceptInviteExistingUserData,
  AuthAcceptInviteExistingUserError,
  AuthAcceptInviteExistingUserResponse,
  AuthAcceptInviteNewUserData,
  AuthAcceptInviteNewUserError,
  AuthAcceptInviteNewUserResponse,
  AuthCheckInviteData,
  AuthCheckInviteError,
  AuthCheckInviteResponse,
  AuthSignupData,
  AuthSignupError,
  AuthSignupResponse,
  CheckdAddressValidateData,
  CheckdAddressValidateError,
  CheckdAddressValidateResponse,
  CheckdAutoEftDashboardData,
  CheckdAutoEftDashboardError,
  CheckdAutoEftDashboardResponse,
  CheckdDashboardMetricsData,
  CheckdDashboardMetricsError,
  CheckdDashboardMetricsResponse,
  EftAutoPaymentListData,
  EftAutoPaymentListError,
  EftAutoPaymentListResponse,
  FileUploadIntentData,
  FileUploadIntentError,
  FileUploadIntentResponse,
  FileViewData,
  FileViewError,
  GetFeatureFlagsData,
  GetFeatureFlagsError,
  GetFeatureFlagsResponse,
  GetHealthData,
  GetHealthError,
  GetHealthResponse,
  GetLookupTableValuesData,
  GetLookupTableValuesError,
  GetLookupTableValuesResponse,
  GetSelfAppDataData,
  GetSelfAppDataError,
  GetSelfAppDataResponse,
  IduAuditListData,
  IduAuditListError,
  IduAuditListResponse,
  IduAutoEftMerchantWarriorCheckData,
  IduAutoEftMerchantWarriorCheckError,
  IduAutoEftMerchantWarriorCheckResponse,
  IduAutoEftMetricsData,
  IduAutoEftMetricsError,
  IduAutoEftMetricsResponse,
  IduAutoEftRecordsData,
  IduAutoEftRecordsError,
  IduAutoEftRecordsResponse,
  IduAutoEftResolutionRecordData,
  IduAutoEftResolutionRecordError,
  IduAutoEftResolutionRecordResponse,
  IduAutoEftRetryableData,
  IduAutoEftRetryableError,
  IduAutoEftRetryableResponse,
  IduBndryAlertHistoryData,
  IduBndryAlertHistoryError,
  IduBndryAlertHistoryResponse,
  IduCheckdVenueSettingGetData,
  IduCheckdVenueSettingGetError,
  IduCheckdVenueSettingGetResponse,
  IduCheckdVenueSettingUpdateData,
  IduCheckdVenueSettingUpdateError,
  IduCheckdVenueSettingUpdateResponse,
  IduDashboardCheckdMetricsData,
  IduDashboardCheckdMetricsError,
  IduDashboardCheckdMetricsResponse,
  IduDashboardCheckdPayoutListData,
  IduDashboardCheckdPayoutListError,
  IduDashboardCheckdPayoutListResponse,
  IduDashboardCheckdVenueMetricsData,
  IduDashboardCheckdVenueMetricsError,
  IduDashboardCheckdVenueMetricsResponse,
  IduDashboardCheckdVenueTablesData,
  IduDashboardCheckdVenueTablesError,
  IduDashboardCheckdVenueTablesResponse,
  IduDashboardMetricsData,
  IduDashboardMetricsError,
  IduDashboardMetricsResponse,
  IduDashboardUserAddData,
  IduDashboardUserAddError,
  IduDashboardUserAddResponse,
  IduDashboardUsersListData,
  IduDashboardUsersListError,
  IduDashboardUsersListResponse,
  IduInAppMessageCreateData,
  IduInAppMessageCreateError,
  IduInAppMessageCreateResponse,
  IduInAppMessageDeleteData,
  IduInAppMessageDeleteError,
  IduInAppMessageDeleteResponse,
  IduInAppMessageGetData,
  IduInAppMessageGetError,
  IduInAppMessageGetResponse,
  IduInAppMessageListData,
  IduInAppMessageListError,
  IduInAppMessageListResponse,
  IduInAppMessageUpdateData,
  IduInAppMessageUpdateError,
  IduInAppMessageUpdateResponse,
  IduInviteAvailabilityData,
  IduInviteAvailabilityError,
  IduInviteAvailabilityResponse,
  IduInviteListData,
  IduInviteListError,
  IduInviteListResponse,
  IduInviteManualAcceptData,
  IduInviteManualAcceptError,
  IduInviteManualAcceptResponse,
  IduInviteResendData,
  IduInviteResendError,
  IduInviteResendResponse,
  IduInviteRevokeData,
  IduInviteRevokeError,
  IduInviteRevokeResponse,
  IduInviteSkipAndAddData,
  IduInviteSkipAndAddError,
  IduInviteSkipAndAddResponse,
  IduKycDashboardData,
  IduKycDashboardError,
  IduKycDashboardResponse,
  IduLogsListData,
  IduLogsListError,
  IduLogsListResponse2,
  IduNightlifeVenueLinkData,
  IduNightlifeVenueLinkError,
  IduNightlifeVenueLinkResponse,
  IduNightlifeVenueLinkToData,
  IduNightlifeVenueLinkToError,
  IduNightlifeVenueLinkToResponse,
  IduNightlifeVenueListData,
  IduNightlifeVenueListError,
  IduNightlifeVenueListResponse,
  IduNightlifeVenueRelinkData,
  IduNightlifeVenueRelinkError,
  IduNightlifeVenueRelinkResponse,
  IduPayoutAuditData,
  IduPayoutAuditError,
  IduPayoutAuditResponse,
  IduPayoutCorrectionData,
  IduPayoutCorrectionError,
  IduPayoutCorrectionPreviewData,
  IduPayoutCorrectionPreviewError,
  IduPayoutCorrectionPreviewResponse,
  IduPayoutCorrectionResponse,
  IduPayoutDetailData,
  IduPayoutDetailError,
  IduPayoutDetailResponse,
  IduPayoutVenueMoveData,
  IduPayoutVenueMoveError,
  IduPayoutVenueMovePreviewData,
  IduPayoutVenueMovePreviewError,
  IduPayoutVenueMovePreviewResponse,
  IduPayoutVenueMoveResponse,
  IduPepCheckActivityListData,
  IduPepCheckActivityListError,
  IduPepCheckActivityListResponse,
  IduPepCheckRunStatsData,
  IduPepCheckRunStatsError,
  IduPepCheckRunStatsResponse,
  IduSettingsGetData,
  IduSettingsGetError,
  IduSettingsGetResponse,
  IduSettingsUpdateData,
  IduSettingsUpdateError,
  IduSettingsUpdateResponse,
  IduUserAssignToVenueData,
  IduUserAssignToVenueError,
  IduUserAssignToVenueResponse,
  IduUserCreateData,
  IduUserCreateError,
  IduUserCreateResponse2,
  IduUserEmailSearchData,
  IduUserEmailSearchError,
  IduUserEmailSearchResponse,
  IduUserGetData,
  IduUserGetError,
  IduUserGetResponse,
  IduUserInviteCreateData,
  IduUserInviteCreateError,
  IduUserInviteCreateResponse,
  IduUserListData,
  IduUserListError,
  IduUserListResponse,
  IduUserPasswordChangeData,
  IduUserPasswordChangeError,
  IduUserPasswordChangeResponse,
  IduUserRemoveFromVenueData,
  IduUserRemoveFromVenueError,
  IduUserRemoveFromVenueResponse,
  IduUserResetPasswordData,
  IduUserResetPasswordError,
  IduUserResetPasswordResponse,
  IduUserSearchData,
  IduUserSearchError,
  IduUserSearchResponse2,
  IduUserTwoStepCodeData,
  IduUserTwoStepCodeError,
  IduUserTwoStepCodeResponse,
  IduUserTwoStepData,
  IduUserTwoStepError,
  IduUserTwoStepResetData,
  IduUserTwoStepResetError,
  IduUserTwoStepResetResponse,
  IduUserTwoStepResponse,
  IduUserTwoStepUpdateData,
  IduUserTwoStepUpdateError,
  IduUserTwoStepUpdateResponse,
  IduUserUpdateData,
  IduUserUpdateError,
  IduUserUpdateResponse,
  IduVenueApplicationAssignData,
  IduVenueApplicationAssignError,
  IduVenueApplicationAssignResponse2,
  IduVenueApplicationRemoveData,
  IduVenueApplicationRemoveError,
  IduVenueApplicationRemoveResponse2,
  IduVenueCreateData,
  IduVenueCreateError,
  IduVenueCreateResponse,
  IduVenueGetData,
  IduVenueGetError,
  IduVenueGetResponse,
  IduVenueListData,
  IduVenueListError,
  IduVenueListResponse,
  IduVenueMwCredentialsStatusData,
  IduVenueMwCredentialsStatusError,
  IduVenueMwCredentialsStatusResponse,
  IduVenueMwCredentialsUpdateData,
  IduVenueMwCredentialsUpdateError,
  IduVenueMwCredentialsUpdateResponse,
  IduVenueNightlifeCreateData,
  IduVenueNightlifeCreateError,
  IduVenueNightlifeCreateResponse,
  IduVenueNightlifeLegacyManagersData,
  IduVenueNightlifeLegacyManagersError,
  IduVenueNightlifeLegacyManagersResponse,
  IduVenueNightlifeLinksData,
  IduVenueNightlifeLinksError,
  IduVenueNightlifeLinksResponse,
  IduVenueNightlifeSettingsGetData,
  IduVenueNightlifeSettingsGetError,
  IduVenueNightlifeSettingsGetResponse,
  IduVenueNightlifeSettingsUpdateData,
  IduVenueNightlifeSettingsUpdateError,
  IduVenueNightlifeSettingsUpdateResponse,
  IduVenueRolesListData,
  IduVenueRolesListError,
  IduVenueRolesListResponse,
  IduVenueUpdateData,
  IduVenueUpdateError,
  IduVenueUpdateResponse,
  IduVenueUsersListData,
  IduVenueUsersListError,
  IduVenueUsersListResponse,
  InAppMessageMarkReadData,
  InAppMessageMarkReadError,
  InAppMessageMarkReadResponse2,
  InAppMessageUnreadForApplicationListData,
  InAppMessageUnreadForApplicationListError,
  InAppMessageUnreadForApplicationListResponse2,
  InternalNightlifeGrantCreateData,
  InternalNightlifeGrantCreateError,
  InternalNightlifeGrantCreateResponse2,
  LogCreateData,
  LogCreateError,
  LogCreateResponse,
  NightlifeManagerInviteData,
  NightlifeManagerInviteError,
  NightlifeManagerInviteResendData,
  NightlifeManagerInviteResendError,
  NightlifeManagerInviteResendResponse,
  NightlifeManagerInviteResponse,
  NightlifeManagerInviteRevokeData,
  NightlifeManagerInviteRevokeError,
  NightlifeManagerInviteRevokeResponse,
  NightlifeManagerListData,
  NightlifeManagerListError,
  NightlifeManagerListResponse,
  NightlifeManagerRemoveData,
  NightlifeManagerRemoveError,
  NightlifeManagerRemoveResponse,
  OauthProvisionData,
  OauthProvisionError,
  OauthProvisionResponse2,
  PatronAuditTrailData,
  PatronAuditTrailError,
  PatronAuditTrailResponse,
  PatronCaptureAddData,
  PatronCaptureAddError,
  PatronCaptureAddResponse,
  PatronCaptureCompareData,
  PatronCaptureCompareError,
  PatronCaptureCompareResponse,
  PatronCreateData,
  PatronCreateError,
  PatronCreateResponse,
  PatronDetailsUpdateData,
  PatronDetailsUpdateError,
  PatronDetailsUpdateResponse,
  PatronDvsCheckRunData,
  PatronDvsCheckRunError,
  PatronDvsCheckRunResponse,
  PatronGetData,
  PatronGetError,
  PatronGetResponse,
  PatronIdentityCheckAttachData,
  PatronIdentityCheckAttachError,
  PatronIdentityCheckAttachResponse,
  PatronIdentityCheckDigitalData,
  PatronIdentityCheckDigitalError,
  PatronIdentityCheckDigitalResponse,
  PatronListData,
  PatronListError,
  PatronListResponse,
  PatronPepCheckDecideData,
  PatronPepCheckDecideError,
  PatronPepCheckDecideResponse,
  PatronPepCheckRunData,
  PatronPepCheckRunError,
  PatronPepCheckRunResponse,
  PatronSearchData,
  PatronSearchError,
  PatronSearchResponse,
  PatronTypeUpdateData,
  PatronTypeUpdateError,
  PatronTypeUpdateResponse,
  PayoutAuditTrailData,
  PayoutAuditTrailError,
  PayoutAuditTrailResponse,
  PayoutConfirmationOfPayeeNotesUpdateData,
  PayoutConfirmationOfPayeeNotesUpdateError,
  PayoutConfirmationOfPayeeNotesUpdateResponse,
  PayoutConfirmationOfPayeeReVerifyData,
  PayoutConfirmationOfPayeeReVerifyError,
  PayoutConfirmationOfPayeeReVerifyResponse,
  PayoutConfirmationOfPayeeVerifyData,
  PayoutConfirmationOfPayeeVerifyError,
  PayoutConfirmationOfPayeeVerifyResponse,
  PayoutConnectIdShortLinkData,
  PayoutConnectIdVerificationCancelData,
  PayoutConnectIdVerificationCancelError,
  PayoutConnectIdVerificationCancelResponse,
  PayoutConnectIdVerificationStartData,
  PayoutConnectIdVerificationStartError,
  PayoutConnectIdVerificationStartResponse,
  PayoutConnectIdVerificationStatusData,
  PayoutConnectIdVerificationStatusError,
  PayoutConnectIdVerificationStatusResponse,
  PayoutCreateData,
  PayoutCreateError,
  PayoutCreateResponse,
  PayoutDiscardData,
  PayoutDiscardError,
  PayoutDiscardResponse,
  PayoutGetData,
  PayoutGetError,
  PayoutGetResponse,
  PayoutIdentityCheckDigitalData,
  PayoutIdentityCheckDigitalError,
  PayoutIdentityCheckDigitalResponse,
  PayoutListData,
  PayoutListError,
  PayoutListResponse,
  PayoutManagerElevationRefreshData,
  PayoutManagerElevationRefreshError,
  PayoutManagerElevationRefreshResponse,
  PayoutManagerReviewGetData,
  PayoutManagerReviewGetError,
  PayoutManagerReviewGetResponse,
  PayoutManagerReviewPostData,
  PayoutManagerReviewPostError,
  PayoutManagerReviewPostResponse,
  PayoutPhase1PatronIdData,
  PayoutPhase1PatronIdError,
  PayoutPhase1PatronIdResponse,
  PayoutPhase2TicketData,
  PayoutPhase2TicketError,
  PayoutPhase2TicketResponse,
  PayoutPhase3KycData,
  PayoutPhase3KycError,
  PayoutPhase3KycResponse,
  PayoutPhase3KycVerifyData,
  PayoutPhase3KycVerifyError,
  PayoutPhase3KycVerifyResponse,
  PayoutPhase4ContactPaymentData,
  PayoutPhase4ContactPaymentError,
  PayoutPhase4ContactPaymentResponse,
  PayoutPhase5PatronSignOffData,
  PayoutPhase5PatronSignOffError,
  PayoutPhase5PatronSignOffResponse,
  PayoutPhase6AttendantSignOffData,
  PayoutPhase6AttendantSignOffError,
  PayoutPhase6AttendantSignOffResponse,
  PayoutPhase7ManagerSignOffData,
  PayoutPhase7ManagerSignOffError,
  PayoutPhase7ManagerSignOffResponse,
  PayoutPhase8PayoutData,
  PayoutPhase8PayoutError,
  PayoutPhase8PayoutResponse,
  PayoutReceiptSendData,
  PayoutReceiptSendError,
  PayoutReceiptSendResponse,
  PayoutUpdateData,
  PayoutUpdateError,
  PayoutUpdateResponse2,
  PayoutViewData,
  PayoutViewError,
  PayoutViewResponse2,
  PermissionCatalogueListData,
  PermissionCatalogueListError,
  PermissionCatalogueListResponse,
  PokieVenueSettingGetData,
  PokieVenueSettingGetError,
  PokieVenueSettingGetResponse,
  PokieVenueSettingRiskRuleListData,
  PokieVenueSettingRiskRuleListError,
  PokieVenueSettingRiskRuleListResponse,
  PokieVenueSettingUpdateData,
  PokieVenueSettingUpdateError,
  PokieVenueSettingUpdateResponse,
  PpUserInviteData,
  PpUserInviteError,
  PpUserInviteResponse,
  PpUserReinviteData,
  PpUserReinviteError,
  PpUserReinviteResponse,
  PpUserRevokeInviteData,
  PpUserRevokeInviteError,
  PpUserRevokeInviteResponse,
  PpVenueUserCreateData,
  PpVenueUserCreateError,
  PpVenueUserCreateResponse,
  PpVenueUserDeleteData,
  PpVenueUserDeleteError,
  PpVenueUserDeleteResponse,
  PpVenueUserGetData,
  PpVenueUserGetError,
  PpVenueUserGetResponse,
  PpVenueUserListData,
  PpVenueUserListError,
  PpVenueUserListResponse,
  PpVenueUserUpdateData,
  PpVenueUserUpdateError,
  PpVenueUserUpdateResponse,
  ResetPasswordData,
  ResetPasswordError,
  ResetPasswordResponse,
  RiskRegisterAttachmentCreateData,
  RiskRegisterAttachmentCreateError,
  RiskRegisterAttachmentCreateResponse,
  RiskRegisterAttachmentDeleteData,
  RiskRegisterAttachmentDeleteError,
  RiskRegisterAttachmentDeleteResponse,
  RiskRegisterAttachmentGetData,
  RiskRegisterAttachmentGetError,
  RiskRegisterAttachmentGetResponse,
  RiskRegisterCreateData,
  RiskRegisterCreateError,
  RiskRegisterCreateResponse,
  RiskRegisterListData,
  RiskRegisterListError,
  RiskRegisterListResponse,
  RiskRegisterMetricsData,
  RiskRegisterMetricsError,
  RiskRegisterMetricsResponse,
  RiskRegisterPatronSearchData,
  RiskRegisterPatronSearchError,
  RiskRegisterPatronSearchResponse,
  RiskRegisterPayoutSearchData,
  RiskRegisterPayoutSearchError,
  RiskRegisterPayoutSearchResponse,
  RiskRegisterReviewData,
  RiskRegisterReviewError,
  RiskRegisterReviewResponse,
  ScanLicenseData,
  ScanLicenseError,
  ScanLicenseResponse,
  SelfProfileGetData,
  SelfProfileGetError,
  SelfProfileGetResponse2,
  SelfProfileUpdateData,
  SelfProfileUpdateError,
  SelfProfileUpdateResponse2,
  StaffAccessData,
  StaffAccessError,
  StaffAccessResponse,
  TwoStepConfirmMethodData,
  TwoStepConfirmMethodError,
  TwoStepConfirmMethodResponse,
  TwoStepForgetAllDevicesData,
  TwoStepForgetAllDevicesError,
  TwoStepForgetAllDevicesResponse,
  TwoStepForgetDeviceData,
  TwoStepForgetDeviceError,
  TwoStepForgetDeviceResponse,
  TwoStepListDevicesData,
  TwoStepListDevicesError,
  TwoStepListDevicesResponse,
  TwoStepRemoveMethodData,
  TwoStepRemoveMethodError,
  TwoStepRemoveMethodResponse,
  TwoStepRequireData,
  TwoStepRequireError,
  TwoStepRequireResponse,
  TwoStepSendCodeData,
  TwoStepSendCodeError,
  TwoStepSendCodeResponse,
  TwoStepSetChoiceData,
  TwoStepSetChoiceError,
  TwoStepSetChoiceResponse,
  TwoStepSetPreferredData,
  TwoStepSetPreferredError,
  TwoStepSetPreferredResponse,
  TwoStepStartAuthenticatorData,
  TwoStepStartAuthenticatorError,
  TwoStepStartAuthenticatorResponse,
  TwoStepStartSmsData,
  TwoStepStartSmsError,
  TwoStepStartSmsResponse,
  TwoStepStatusData,
  TwoStepStatusError,
  TwoStepStatusResponse,
  TwoStepVerifyData,
  TwoStepVerifyDeviceData,
  TwoStepVerifyDeviceError,
  TwoStepVerifyDeviceResponse,
  TwoStepVerifyError,
  TwoStepVerifyResponse,
  UserGetDataData,
  UserGetDataError,
  UserGetDataResponse,
  UserPinCheckData,
  UserPinCheckError,
  UserPinCheckResponse2,
  UserPublicProfileData,
  UserPublicProfileError,
  UserPublicProfileResponse,
  UserUpdateProfileData,
  UserUpdateProfileError,
  UserUpdateProfileResponse,
  VenueAssignableRoleListData,
  VenueAssignableRoleListError,
  VenueAssignableRoleListResponse,
  VenueRoleCreateData,
  VenueRoleCreateError,
  VenueRoleCreateResponse,
  VenueRoleDeleteData,
  VenueRoleDeleteError,
  VenueRoleDeleteResponse,
  VenueRoleGetData,
  VenueRoleGetError,
  VenueRoleGetResponse,
  VenueRoleListData,
  VenueRoleListError,
  VenueRoleListResponse2,
  VenueRolePermissionsUpdateData,
  VenueRolePermissionsUpdateError,
  VenueRolePermissionsUpdateResponse,
  VenueRoleUpdateData,
  VenueRoleUpdateError,
  VenueRoleUpdateResponse,
  VoiSettingGetData,
  VoiSettingGetError,
  VoiSettingGetResponse,
  VoiSettingUpdateData,
  VoiSettingUpdateError,
  VoiSettingUpdateResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getHealthQueryKey = (options?: Options<GetHealthData>) =>
  createQueryKey('getHealth', options);

/**
 * Health endpoint
 *
 * Get server information and status.
 */
export const getHealthOptions = (options?: Options<GetHealthData>) =>
  queryOptions<
    GetHealthResponse,
    GetHealthError,
    GetHealthResponse,
    ReturnType<typeof getHealthQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHealthQueryKey(options),
  });

export const getFeatureFlagsQueryKey = (options?: Options<GetFeatureFlagsData>) =>
  createQueryKey('getFeatureFlags', options);

/**
 * Platform feature flags
 *
 * Platform-wide feature flags the frontends must mirror.
 */
export const getFeatureFlagsOptions = (options?: Options<GetFeatureFlagsData>) =>
  queryOptions<
    GetFeatureFlagsResponse,
    GetFeatureFlagsError,
    GetFeatureFlagsResponse,
    ReturnType<typeof getFeatureFlagsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFeatureFlags({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFeatureFlagsQueryKey(options),
  });

/**
 * Log
 *
 * Log
 */
export const logCreateMutation = (
  options?: Partial<Options<LogCreateData>>,
): UseMutationOptions<LogCreateResponse, LogCreateError, Options<LogCreateData>> => {
  const mutationOptions: UseMutationOptions<
    LogCreateResponse,
    LogCreateError,
    Options<LogCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await logCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reset password
 *
 * Request to reset the users password via email address
 */
export const resetPasswordMutation = (
  options?: Partial<Options<ResetPasswordData>>,
): UseMutationOptions<ResetPasswordResponse, ResetPasswordError, Options<ResetPasswordData>> => {
  const mutationOptions: UseMutationOptions<
    ResetPasswordResponse,
    ResetPasswordError,
    Options<ResetPasswordData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetPassword({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Signup User
 *
 * Request to signup user
 */
export const authSignupMutation = (
  options?: Partial<Options<AuthSignupData>>,
): UseMutationOptions<AuthSignupResponse, AuthSignupError, Options<AuthSignupData>> => {
  const mutationOptions: UseMutationOptions<
    AuthSignupResponse,
    AuthSignupError,
    Options<AuthSignupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authSignup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Provision an OAuth sign-up
 *
 * Create-or-merge the DB user for a freshly OAuth-authenticated Firebase identity.
 */
export const oauthProvisionMutation = (
  options?: Partial<Options<OauthProvisionData>>,
): UseMutationOptions<
  OauthProvisionResponse2,
  OauthProvisionError,
  Options<OauthProvisionData>
> => {
  const mutationOptions: UseMutationOptions<
    OauthProvisionResponse2,
    OauthProvisionError,
    Options<OauthProvisionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await oauthProvision({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Signup User with Invite Id
 *
 * Request to sign up user with a signed token
 */
export const authAcceptInviteNewUserMutation = (
  options?: Partial<Options<AuthAcceptInviteNewUserData>>,
): UseMutationOptions<
  AuthAcceptInviteNewUserResponse,
  AuthAcceptInviteNewUserError,
  Options<AuthAcceptInviteNewUserData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthAcceptInviteNewUserResponse,
    AuthAcceptInviteNewUserError,
    Options<AuthAcceptInviteNewUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authAcceptInviteNewUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Signup User with Invite Id
 *
 * Request to sign up user with a signed token
 */
export const authAcceptInviteExistingUserMutation = (
  options?: Partial<Options<AuthAcceptInviteExistingUserData>>,
): UseMutationOptions<
  AuthAcceptInviteExistingUserResponse,
  AuthAcceptInviteExistingUserError,
  Options<AuthAcceptInviteExistingUserData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthAcceptInviteExistingUserResponse,
    AuthAcceptInviteExistingUserError,
    Options<AuthAcceptInviteExistingUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authAcceptInviteExistingUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authCheckInviteQueryKey = (options: Options<AuthCheckInviteData>) =>
  createQueryKey('authCheckInvite', options);

/**
 * Signup User with Invite Id
 *
 * Request to sign up user with a signed token
 */
export const authCheckInviteOptions = (options: Options<AuthCheckInviteData>) =>
  queryOptions<
    AuthCheckInviteResponse,
    AuthCheckInviteError,
    AuthCheckInviteResponse,
    ReturnType<typeof authCheckInviteQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authCheckInvite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: authCheckInviteQueryKey(options),
  });

export const twoStepStatusQueryKey = (options?: Options<TwoStepStatusData>) =>
  createQueryKey('twoStepStatus', options);

/**
 * Get two-step sign-in status
 */
export const twoStepStatusOptions = (options?: Options<TwoStepStatusData>) =>
  queryOptions<
    TwoStepStatusResponse,
    TwoStepStatusError,
    TwoStepStatusResponse,
    ReturnType<typeof twoStepStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await twoStepStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: twoStepStatusQueryKey(options),
  });

/**
 * Turn two-step sign-in on or off
 */
export const twoStepSetChoiceMutation = (
  options?: Partial<Options<TwoStepSetChoiceData>>,
): UseMutationOptions<
  TwoStepSetChoiceResponse,
  TwoStepSetChoiceError,
  Options<TwoStepSetChoiceData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepSetChoiceResponse,
    TwoStepSetChoiceError,
    Options<TwoStepSetChoiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepSetChoice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Require two-step sign-in for the signed-in account
 */
export const twoStepRequireMutation = (
  options?: Partial<Options<TwoStepRequireData>>,
): UseMutationOptions<TwoStepRequireResponse, TwoStepRequireError, Options<TwoStepRequireData>> => {
  const mutationOptions: UseMutationOptions<
    TwoStepRequireResponse,
    TwoStepRequireError,
    Options<TwoStepRequireData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepRequire({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start setting up an authenticator app
 */
export const twoStepStartAuthenticatorMutation = (
  options?: Partial<Options<TwoStepStartAuthenticatorData>>,
): UseMutationOptions<
  TwoStepStartAuthenticatorResponse,
  TwoStepStartAuthenticatorError,
  Options<TwoStepStartAuthenticatorData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepStartAuthenticatorResponse,
    TwoStepStartAuthenticatorError,
    Options<TwoStepStartAuthenticatorData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepStartAuthenticator({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start setting up text message codes, or changing their number
 *
 * On text messages already set up, this starts changing the number and needs a passed second step. The code goes to the new number, and the old number keeps working until the new one is confirmed.
 */
export const twoStepStartSmsMutation = (
  options?: Partial<Options<TwoStepStartSmsData>>,
): UseMutationOptions<
  TwoStepStartSmsResponse,
  TwoStepStartSmsError,
  Options<TwoStepStartSmsData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepStartSmsResponse,
    TwoStepStartSmsError,
    Options<TwoStepStartSmsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepStartSms({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Confirm a method with its first code
 *
 * Also confirms a text message number change, with the code sent to the new number. Remembered devices are then forgotten.
 */
export const twoStepConfirmMethodMutation = (
  options?: Partial<Options<TwoStepConfirmMethodData>>,
): UseMutationOptions<
  TwoStepConfirmMethodResponse,
  TwoStepConfirmMethodError,
  Options<TwoStepConfirmMethodData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepConfirmMethodResponse,
    TwoStepConfirmMethodError,
    Options<TwoStepConfirmMethodData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepConfirmMethod({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a method
 */
export const twoStepRemoveMethodMutation = (
  options?: Partial<Options<TwoStepRemoveMethodData>>,
): UseMutationOptions<
  TwoStepRemoveMethodResponse,
  TwoStepRemoveMethodError,
  Options<TwoStepRemoveMethodData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepRemoveMethodResponse,
    TwoStepRemoveMethodError,
    Options<TwoStepRemoveMethodData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepRemoveMethod({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Make a method the one asked for first
 */
export const twoStepSetPreferredMutation = (
  options?: Partial<Options<TwoStepSetPreferredData>>,
): UseMutationOptions<
  TwoStepSetPreferredResponse,
  TwoStepSetPreferredError,
  Options<TwoStepSetPreferredData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepSetPreferredResponse,
    TwoStepSetPreferredError,
    Options<TwoStepSetPreferredData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepSetPreferred({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send a sign-in code by text message
 */
export const twoStepSendCodeMutation = (
  options?: Partial<Options<TwoStepSendCodeData>>,
): UseMutationOptions<
  TwoStepSendCodeResponse,
  TwoStepSendCodeError,
  Options<TwoStepSendCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepSendCodeResponse,
    TwoStepSendCodeError,
    Options<TwoStepSendCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepSendCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Pass the second step for this sign-in
 */
export const twoStepVerifyMutation = (
  options?: Partial<Options<TwoStepVerifyData>>,
): UseMutationOptions<TwoStepVerifyResponse, TwoStepVerifyError, Options<TwoStepVerifyData>> => {
  const mutationOptions: UseMutationOptions<
    TwoStepVerifyResponse,
    TwoStepVerifyError,
    Options<TwoStepVerifyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepVerify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Pass the second step on a remembered device
 */
export const twoStepVerifyDeviceMutation = (
  options?: Partial<Options<TwoStepVerifyDeviceData>>,
): UseMutationOptions<
  TwoStepVerifyDeviceResponse,
  TwoStepVerifyDeviceError,
  Options<TwoStepVerifyDeviceData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepVerifyDeviceResponse,
    TwoStepVerifyDeviceError,
    Options<TwoStepVerifyDeviceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepVerifyDevice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Forget every remembered device
 */
export const twoStepForgetAllDevicesMutation = (
  options?: Partial<Options<TwoStepForgetAllDevicesData>>,
): UseMutationOptions<
  TwoStepForgetAllDevicesResponse,
  TwoStepForgetAllDevicesError,
  Options<TwoStepForgetAllDevicesData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepForgetAllDevicesResponse,
    TwoStepForgetAllDevicesError,
    Options<TwoStepForgetAllDevicesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepForgetAllDevices({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const twoStepListDevicesQueryKey = (options?: Options<TwoStepListDevicesData>) =>
  createQueryKey('twoStepListDevices', options);

/**
 * List the remembered devices
 */
export const twoStepListDevicesOptions = (options?: Options<TwoStepListDevicesData>) =>
  queryOptions<
    TwoStepListDevicesResponse,
    TwoStepListDevicesError,
    TwoStepListDevicesResponse,
    ReturnType<typeof twoStepListDevicesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await twoStepListDevices({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: twoStepListDevicesQueryKey(options),
  });

/**
 * Forget one remembered device
 */
export const twoStepForgetDeviceMutation = (
  options?: Partial<Options<TwoStepForgetDeviceData>>,
): UseMutationOptions<
  TwoStepForgetDeviceResponse,
  TwoStepForgetDeviceError,
  Options<TwoStepForgetDeviceData>
> => {
  const mutationOptions: UseMutationOptions<
    TwoStepForgetDeviceResponse,
    TwoStepForgetDeviceError,
    Options<TwoStepForgetDeviceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await twoStepForgetDevice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const staffAccessQueryKey = (options?: Options<StaffAccessData>) =>
  createQueryKey('staffAccess', options);

/**
 * Whether the signed-in account is iDU staff (holds iDU Dashboard access)
 */
export const staffAccessOptions = (options?: Options<StaffAccessData>) =>
  queryOptions<
    StaffAccessResponse,
    StaffAccessError,
    StaffAccessResponse,
    ReturnType<typeof staffAccessQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await staffAccess({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: staffAccessQueryKey(options),
  });

export const userPublicProfileQueryKey = (options: Options<UserPublicProfileData>) =>
  createQueryKey('userPublicProfile', options);

/**
 * Get public user info
 *
 * Retrieve the user you are authenticated as
 */
export const userPublicProfileOptions = (options: Options<UserPublicProfileData>) =>
  queryOptions<
    UserPublicProfileResponse,
    UserPublicProfileError,
    UserPublicProfileResponse,
    ReturnType<typeof userPublicProfileQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userPublicProfile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userPublicProfileQueryKey(options),
  });

/**
 * Scan a digital license
 *
 * Scan and validate a VIC Roads or Service Victoria digital credential
 */
export const scanLicenseMutation = (
  options?: Partial<Options<ScanLicenseData>>,
): UseMutationOptions<ScanLicenseResponse, ScanLicenseError, Options<ScanLicenseData>> => {
  const mutationOptions: UseMutationOptions<
    ScanLicenseResponse,
    ScanLicenseError,
    Options<ScanLicenseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await scanLicense({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSelfAppDataQueryKey = (options?: Options<GetSelfAppDataData>) =>
  createQueryKey('getSelfAppData', options);

/**
 * Get user tied to auth
 *
 * Retrieve the currently authenticated user and their venues.
 */
export const getSelfAppDataOptions = (options?: Options<GetSelfAppDataData>) =>
  queryOptions<
    GetSelfAppDataResponse,
    GetSelfAppDataError,
    GetSelfAppDataResponse,
    ReturnType<typeof getSelfAppDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSelfAppData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSelfAppDataQueryKey(options),
  });

export const selfProfileGetQueryKey = (options?: Options<SelfProfileGetData>) =>
  createQueryKey('selfProfileGet', options);

/**
 * Get your profile
 *
 * Retrieve the authenticated caller's own profile
 */
export const selfProfileGetOptions = (options?: Options<SelfProfileGetData>) =>
  queryOptions<
    SelfProfileGetResponse2,
    SelfProfileGetError,
    SelfProfileGetResponse2,
    ReturnType<typeof selfProfileGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await selfProfileGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: selfProfileGetQueryKey(options),
  });

/**
 * Update your profile
 *
 * Update the authenticated caller's own profile and access PIN
 */
export const selfProfileUpdateMutation = (
  options?: Partial<Options<SelfProfileUpdateData>>,
): UseMutationOptions<
  SelfProfileUpdateResponse2,
  SelfProfileUpdateError,
  Options<SelfProfileUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SelfProfileUpdateResponse2,
    SelfProfileUpdateError,
    Options<SelfProfileUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await selfProfileUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const userGetDataQueryKey = (options?: Options<UserGetDataData>) =>
  createQueryKey('userGetData', options);

/**
 * Get your profile
 *
 * Retrieve the authenticated caller's own profile
 *
 * @deprecated
 */
export const userGetDataOptions = (options?: Options<UserGetDataData>) =>
  queryOptions<
    UserGetDataResponse,
    UserGetDataError,
    UserGetDataResponse,
    ReturnType<typeof userGetDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userGetData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userGetDataQueryKey(options),
  });

/**
 * Update your profile
 *
 * Update the authenticated caller's own profile and access PIN
 *
 * @deprecated
 */
export const userUpdateProfileMutation = (
  options?: Partial<Options<UserUpdateProfileData>>,
): UseMutationOptions<
  UserUpdateProfileResponse,
  UserUpdateProfileError,
  Options<UserUpdateProfileData>
> => {
  const mutationOptions: UseMutationOptions<
    UserUpdateProfileResponse,
    UserUpdateProfileError,
    Options<UserUpdateProfileData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userUpdateProfile({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const inAppMessageUnreadForApplicationListQueryKey = (
  options: Options<InAppMessageUnreadForApplicationListData>,
) => createQueryKey('inAppMessageUnreadForApplicationList', options);

/**
 * List in-app messages
 *
 * List all in-app messages
 */
export const inAppMessageUnreadForApplicationListOptions = (
  options: Options<InAppMessageUnreadForApplicationListData>,
) =>
  queryOptions<
    InAppMessageUnreadForApplicationListResponse2,
    InAppMessageUnreadForApplicationListError,
    InAppMessageUnreadForApplicationListResponse2,
    ReturnType<typeof inAppMessageUnreadForApplicationListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await inAppMessageUnreadForApplicationList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: inAppMessageUnreadForApplicationListQueryKey(options),
  });

/**
 * Mark in-app messages as read
 *
 * Mark one or more in-app messages as read for the authenticated user
 */
export const inAppMessageMarkReadMutation = (
  options?: Partial<Options<InAppMessageMarkReadData>>,
): UseMutationOptions<
  InAppMessageMarkReadResponse2,
  InAppMessageMarkReadError,
  Options<InAppMessageMarkReadData>
> => {
  const mutationOptions: UseMutationOptions<
    InAppMessageMarkReadResponse2,
    InAppMessageMarkReadError,
    Options<InAppMessageMarkReadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inAppMessageMarkRead({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLookupTableValuesQueryKey = (options: Options<GetLookupTableValuesData>) =>
  createQueryKey('getLookupTableValues', options);

/**
 * Lookup Table Retrieve One / Many
 *
 * Allows you to retrieve the values from one or many lookup tables
 */
export const getLookupTableValuesOptions = (options: Options<GetLookupTableValuesData>) =>
  queryOptions<
    GetLookupTableValuesResponse,
    GetLookupTableValuesError,
    GetLookupTableValuesResponse,
    ReturnType<typeof getLookupTableValuesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLookupTableValues({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLookupTableValuesQueryKey(options),
  });

/**
 * File Upload Intent
 *
 * File Upload Intent
 */
export const fileUploadIntentMutation = (
  options?: Partial<Options<FileUploadIntentData>>,
): UseMutationOptions<
  FileUploadIntentResponse,
  FileUploadIntentError,
  Options<FileUploadIntentData>
> => {
  const mutationOptions: UseMutationOptions<
    FileUploadIntentResponse,
    FileUploadIntentError,
    Options<FileUploadIntentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await fileUploadIntent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const fileViewQueryKey = (options: Options<FileViewData>) =>
  createQueryKey('fileView', options);

/**
 * returns a redirect to the signed file url
 */
export const fileViewOptions = (options: Options<FileViewData>) =>
  queryOptions<unknown, FileViewError, unknown, ReturnType<typeof fileViewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileView({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: fileViewQueryKey(options),
  });

export const payoutConnectIdShortLinkQueryKey = (options: Options<PayoutConnectIdShortLinkData>) =>
  createQueryKey('payoutConnectIdShortLink', options);

export const payoutConnectIdShortLinkOptions = (options: Options<PayoutConnectIdShortLinkData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof payoutConnectIdShortLinkQueryKey>>(
    {
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await payoutConnectIdShortLink({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: payoutConnectIdShortLinkQueryKey(options),
    },
  );

/**
 * Propose a structured breakdown of a patron address
 *
 * Validates an address entered during payout capture and returns the structured parts with per-part provenance. Every refusal — the venue is not on automated EFT, the platform switch is off, the per-venue ceiling is exceeded, or the provider errored or exceeded its deadline — answers `available: false` and names itself in `cause` for the audit record (FR-024), and none of them blocks capture (FR-008). An address the validator ran against but matched to no real place answers `available: true` with `resolved: false`, which does block capture until the parts are entered manually (FR-008a).
 */
export const checkdAddressValidateMutation = (
  options?: Partial<Options<CheckdAddressValidateData>>,
): UseMutationOptions<
  CheckdAddressValidateResponse,
  CheckdAddressValidateError,
  Options<CheckdAddressValidateData>
> => {
  const mutationOptions: UseMutationOptions<
    CheckdAddressValidateResponse,
    CheckdAddressValidateError,
    Options<CheckdAddressValidateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await checkdAddressValidate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const payoutListQueryKey = (options: Options<PayoutListData>) =>
  createQueryKey('payoutList', options);

/**
 * List Payouts
 *
 * Retrieve paginated list of payouts for venue
 */
export const payoutListOptions = (options: Options<PayoutListData>) =>
  queryOptions<
    PayoutListResponse,
    PayoutListError,
    PayoutListResponse,
    ReturnType<typeof payoutListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await payoutList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: payoutListQueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const payoutListInfiniteQueryKey = (
  options: Options<PayoutListData>,
): QueryKey<Options<PayoutListData>> => createQueryKey('payoutList', options, true);

/**
 * List Payouts
 *
 * Retrieve paginated list of payouts for venue
 */
export const payoutListInfiniteOptions = (options: Options<PayoutListData>) => {
  const opts = infiniteQueryOptions<
    PayoutListResponse,
    PayoutListError,
    InfiniteData<PayoutListResponse>,
    QueryKey<Options<PayoutListData>>,
    string | Pick<QueryKey<Options<PayoutListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PayoutListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await payoutList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: payoutListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Payout with Ticket Details
 *
 * Create a new payout with ticket photo and details
 */
export const payoutCreateMutation = (
  options?: Partial<Options<PayoutCreateData>>,
): UseMutationOptions<PayoutCreateResponse, PayoutCreateError, Options<PayoutCreateData>> => {
  const mutationOptions: UseMutationOptions<
    PayoutCreateResponse,
    PayoutCreateError,
    Options<PayoutCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const payoutGetQueryKey = (options: Options<PayoutGetData>) =>
  createQueryKey('payoutGet', options);

/**
 * Get Payout
 *
 * Retrieve a payout for a venue
 */
export const payoutGetOptions = (options: Options<PayoutGetData>) =>
  queryOptions<
    PayoutGetResponse,
    PayoutGetError,
    PayoutGetResponse,
    ReturnType<typeof payoutGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await payoutGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: payoutGetQueryKey(options),
  });

/**
 * Update Payout
 *
 * Allows a manager to correct patron name, ID info, or payment details on a payout. Staff may do so only while elevated, sending the manager PIN login's token in x-temporary-manager-token. If patron name changes, the linked patron record is unlinked. If patron name or ID info changes, the KYC DVS outcome is cleared to allow re-verification. The response includes full payout state so the frontend can detect KYC breakage via payoutState.
 */
export const payoutUpdateMutation = (
  options?: Partial<Options<PayoutUpdateData>>,
): UseMutationOptions<PayoutUpdateResponse2, PayoutUpdateError, Options<PayoutUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    PayoutUpdateResponse2,
    PayoutUpdateError,
    Options<PayoutUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Record Payout View
 *
 * Record that the authenticated user viewed a payout
 */
export const payoutViewMutation = (
  options?: Partial<Options<PayoutViewData>>,
): UseMutationOptions<PayoutViewResponse2, PayoutViewError, Options<PayoutViewData>> => {
  const mutationOptions: UseMutationOptions<
    PayoutViewResponse2,
    PayoutViewError,
    Options<PayoutViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Summary
 *
 * Description
 */
export const payoutReceiptSendMutation = (
  options?: Partial<Options<PayoutReceiptSendData>>,
): UseMutationOptions<
  PayoutReceiptSendResponse,
  PayoutReceiptSendError,
  Options<PayoutReceiptSendData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutReceiptSendResponse,
    PayoutReceiptSendError,
    Options<PayoutReceiptSendData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutReceiptSend({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase : Patron Identification
 *
 * Update patron identification details and KYC requirement flag
 */
export const payoutPhase1PatronIdMutation = (
  options?: Partial<Options<PayoutPhase1PatronIdData>>,
): UseMutationOptions<
  PayoutPhase1PatronIdResponse,
  PayoutPhase1PatronIdError,
  Options<PayoutPhase1PatronIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase1PatronIdResponse,
    PayoutPhase1PatronIdError,
    Options<PayoutPhase1PatronIdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase1PatronId({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify a digital licence on a payout
 *
 * Verifies a QLD or VIC digital licence, writes its identity onto the payout, and records the payout's identity check
 */
export const payoutIdentityCheckDigitalMutation = (
  options?: Partial<Options<PayoutIdentityCheckDigitalData>>,
): UseMutationOptions<
  PayoutIdentityCheckDigitalResponse,
  PayoutIdentityCheckDigitalError,
  Options<PayoutIdentityCheckDigitalData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutIdentityCheckDigitalResponse,
    PayoutIdentityCheckDigitalError,
    Options<PayoutIdentityCheckDigitalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutIdentityCheckDigital({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel a payout’s ConnectID verification
 *
 * FR-013a — returns the payout to the ordinary identity-capture flow so the attendant can proceed with a document scan. The vendor operation is abandoned, not reversed.
 */
export const payoutConnectIdVerificationCancelMutation = (
  options?: Partial<Options<PayoutConnectIdVerificationCancelData>>,
): UseMutationOptions<
  PayoutConnectIdVerificationCancelResponse,
  PayoutConnectIdVerificationCancelError,
  Options<PayoutConnectIdVerificationCancelData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutConnectIdVerificationCancelResponse,
    PayoutConnectIdVerificationCancelError,
    Options<PayoutConnectIdVerificationCancelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutConnectIdVerificationCancel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const payoutConnectIdVerificationStatusQueryKey = (
  options: Options<PayoutConnectIdVerificationStatusData>,
) => createQueryKey('payoutConnectIdVerificationStatus', options);

/**
 * Read the current state of a payout’s ConnectID verification
 *
 * The attendant’s device polls this rather than the vendor (research R8), and re-reads it on foreground so a backgrounded tablet resumes rather than restarting (FR-027).
 */
export const payoutConnectIdVerificationStatusOptions = (
  options: Options<PayoutConnectIdVerificationStatusData>,
) =>
  queryOptions<
    PayoutConnectIdVerificationStatusResponse,
    PayoutConnectIdVerificationStatusError,
    PayoutConnectIdVerificationStatusResponse,
    ReturnType<typeof payoutConnectIdVerificationStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await payoutConnectIdVerificationStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: payoutConnectIdVerificationStatusQueryKey(options),
  });

/**
 * Start a ConnectID identity verification for a payout
 *
 * Creates or reuses the payout’s vendor entity from the seed name and runs the ConnectID job against it, returning the vendor-issued destination the patron scans.
 */
export const payoutConnectIdVerificationStartMutation = (
  options?: Partial<Options<PayoutConnectIdVerificationStartData>>,
): UseMutationOptions<
  PayoutConnectIdVerificationStartResponse,
  PayoutConnectIdVerificationStartError,
  Options<PayoutConnectIdVerificationStartData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutConnectIdVerificationStartResponse,
    PayoutConnectIdVerificationStartError,
    Options<PayoutConnectIdVerificationStartData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutConnectIdVerificationStart({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase 2: Ticket Details
 *
 * Update ticket photo and ticket details
 */
export const payoutPhase2TicketMutation = (
  options?: Partial<Options<PayoutPhase2TicketData>>,
): UseMutationOptions<
  PayoutPhase2TicketResponse,
  PayoutPhase2TicketError,
  Options<PayoutPhase2TicketData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase2TicketResponse,
    PayoutPhase2TicketError,
    Options<PayoutPhase2TicketData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase2Ticket({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase 3: KYC
 *
 * Submit patron signature and documents
 */
export const payoutPhase3KycMutation = (
  options?: Partial<Options<PayoutPhase3KycData>>,
): UseMutationOptions<
  PayoutPhase3KycResponse,
  PayoutPhase3KycError,
  Options<PayoutPhase3KycData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase3KycResponse,
    PayoutPhase3KycError,
    Options<PayoutPhase3KycData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase3Kyc({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Trigger DVS verification for payout
 *
 * Run DVS/NCC verification and persist outcome
 */
export const payoutPhase3KycVerifyMutation = (
  options?: Partial<Options<PayoutPhase3KycVerifyData>>,
): UseMutationOptions<
  PayoutPhase3KycVerifyResponse,
  PayoutPhase3KycVerifyError,
  Options<PayoutPhase3KycVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase3KycVerifyResponse,
    PayoutPhase3KycVerifyError,
    Options<PayoutPhase3KycVerifyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase3KycVerify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase 4: Contact & Payment Methods
 *
 * Update patron contact details and payment method preferences
 */
export const payoutPhase4ContactPaymentMutation = (
  options?: Partial<Options<PayoutPhase4ContactPaymentData>>,
): UseMutationOptions<
  PayoutPhase4ContactPaymentResponse,
  PayoutPhase4ContactPaymentError,
  Options<PayoutPhase4ContactPaymentData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase4ContactPaymentResponse,
    PayoutPhase4ContactPaymentError,
    Options<PayoutPhase4ContactPaymentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase4ContactPayment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify Confirmation of Payee for a payout (Staff-facing venues)
 *
 * Attendant-triggered check against the BSB/account number/account name currently entered in the Phase 4 form (not yet saved to the payout), used only at Staff-facing venues.
 */
export const payoutConfirmationOfPayeeVerifyMutation = (
  options?: Partial<Options<PayoutConfirmationOfPayeeVerifyData>>,
): UseMutationOptions<
  PayoutConfirmationOfPayeeVerifyResponse,
  PayoutConfirmationOfPayeeVerifyError,
  Options<PayoutConfirmationOfPayeeVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutConfirmationOfPayeeVerifyResponse,
    PayoutConfirmationOfPayeeVerifyError,
    Options<PayoutConfirmationOfPayeeVerifyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutConfirmationOfPayeeVerify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Re-verify Confirmation of Payee for a payout under review
 *
 * Manager-triggered check, used after editing the patron banking details during payout review to clear the stale state on the KYC assessment chip.
 */
export const payoutConfirmationOfPayeeReVerifyMutation = (
  options?: Partial<Options<PayoutConfirmationOfPayeeReVerifyData>>,
): UseMutationOptions<
  PayoutConfirmationOfPayeeReVerifyResponse,
  PayoutConfirmationOfPayeeReVerifyError,
  Options<PayoutConfirmationOfPayeeReVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutConfirmationOfPayeeReVerifyResponse,
    PayoutConfirmationOfPayeeReVerifyError,
    Options<PayoutConfirmationOfPayeeReVerifyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutConfirmationOfPayeeReVerify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save free-text notes against the payout's latest Confirmation of Payee result
 */
export const payoutConfirmationOfPayeeNotesUpdateMutation = (
  options?: Partial<Options<PayoutConfirmationOfPayeeNotesUpdateData>>,
): UseMutationOptions<
  PayoutConfirmationOfPayeeNotesUpdateResponse,
  PayoutConfirmationOfPayeeNotesUpdateError,
  Options<PayoutConfirmationOfPayeeNotesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutConfirmationOfPayeeNotesUpdateResponse,
    PayoutConfirmationOfPayeeNotesUpdateError,
    Options<PayoutConfirmationOfPayeeNotesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutConfirmationOfPayeeNotesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase 5: Patron
 *
 * Collect patron signature for payout confirmation
 */
export const payoutPhase5PatronSignOffMutation = (
  options?: Partial<Options<PayoutPhase5PatronSignOffData>>,
): UseMutationOptions<
  PayoutPhase5PatronSignOffResponse,
  PayoutPhase5PatronSignOffError,
  Options<PayoutPhase5PatronSignOffData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase5PatronSignOffResponse,
    PayoutPhase5PatronSignOffError,
    Options<PayoutPhase5PatronSignOffData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase5PatronSignOff({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase 6: Attendant Signatures
 *
 * Collect attendant signature for payout confirmation
 */
export const payoutPhase6AttendantSignOffMutation = (
  options?: Partial<Options<PayoutPhase6AttendantSignOffData>>,
): UseMutationOptions<
  PayoutPhase6AttendantSignOffResponse,
  PayoutPhase6AttendantSignOffError,
  Options<PayoutPhase6AttendantSignOffData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase6AttendantSignOffResponse,
    PayoutPhase6AttendantSignOffError,
    Options<PayoutPhase6AttendantSignOffData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase6AttendantSignOff({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const payoutManagerReviewGetQueryKey = (options: Options<PayoutManagerReviewGetData>) =>
  createQueryKey('payoutManagerReviewGet', options);

/**
 * Get Manager Review State
 *
 * Orchestrates the manager review process (Patron Linking -> PEP Check -> Sign Off)
 */
export const payoutManagerReviewGetOptions = (options: Options<PayoutManagerReviewGetData>) =>
  queryOptions<
    PayoutManagerReviewGetResponse,
    PayoutManagerReviewGetError,
    PayoutManagerReviewGetResponse,
    ReturnType<typeof payoutManagerReviewGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await payoutManagerReviewGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: payoutManagerReviewGetQueryKey(options),
  });

/**
 * Submit Manager Review Action
 *
 * Execute actions for the manager review process
 */
export const payoutManagerReviewPostMutation = (
  options?: Partial<Options<PayoutManagerReviewPostData>>,
): UseMutationOptions<
  PayoutManagerReviewPostResponse,
  PayoutManagerReviewPostError,
  Options<PayoutManagerReviewPostData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutManagerReviewPostResponse,
    PayoutManagerReviewPostError,
    Options<PayoutManagerReviewPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutManagerReviewPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extend a manager PIN elevation that is still in use
 *
 * Re-issues the temporary manager token for the same manager, attendant and payout with a fresh idle expiry, capped at a fixed time after the PIN was entered. Refused once expired or capped.
 */
export const payoutManagerElevationRefreshMutation = (
  options?: Partial<Options<PayoutManagerElevationRefreshData>>,
): UseMutationOptions<
  PayoutManagerElevationRefreshResponse,
  PayoutManagerElevationRefreshError,
  Options<PayoutManagerElevationRefreshData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutManagerElevationRefreshResponse,
    PayoutManagerElevationRefreshError,
    Options<PayoutManagerElevationRefreshData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutManagerElevationRefresh({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase 7: Manager Approval
 *
 * Submit manager signature to approve payout for processing
 */
export const payoutPhase7ManagerSignOffMutation = (
  options?: Partial<Options<PayoutPhase7ManagerSignOffData>>,
): UseMutationOptions<
  PayoutPhase7ManagerSignOffResponse,
  PayoutPhase7ManagerSignOffError,
  Options<PayoutPhase7ManagerSignOffData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase7ManagerSignOffResponse,
    PayoutPhase7ManagerSignOffError,
    Options<PayoutPhase7ManagerSignOffData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase7ManagerSignOff({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Phase 8: Payouts
 *
 * Record payment confirmations for cash, EFT, and/or cheque
 */
export const payoutPhase8PayoutMutation = (
  options?: Partial<Options<PayoutPhase8PayoutData>>,
): UseMutationOptions<
  PayoutPhase8PayoutResponse,
  PayoutPhase8PayoutError,
  Options<PayoutPhase8PayoutData>
> => {
  const mutationOptions: UseMutationOptions<
    PayoutPhase8PayoutResponse,
    PayoutPhase8PayoutError,
    Options<PayoutPhase8PayoutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutPhase8Payout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Discard Draft Payout
 *
 * Discard draft payout before completion
 */
export const payoutDiscardMutation = (
  options?: Partial<Options<PayoutDiscardData>>,
): UseMutationOptions<PayoutDiscardResponse, PayoutDiscardError, Options<PayoutDiscardData>> => {
  const mutationOptions: UseMutationOptions<
    PayoutDiscardResponse,
    PayoutDiscardError,
    Options<PayoutDiscardData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await payoutDiscard({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const payoutAuditTrailQueryKey = (options: Options<PayoutAuditTrailData>) =>
  createQueryKey('payoutAuditTrail', options);

/**
 * AuditTrail Draft Payout
 *
 * AuditTrail draft payout before completion
 */
export const payoutAuditTrailOptions = (options: Options<PayoutAuditTrailData>) =>
  queryOptions<
    PayoutAuditTrailResponse,
    PayoutAuditTrailError,
    PayoutAuditTrailResponse,
    ReturnType<typeof payoutAuditTrailQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await payoutAuditTrail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: payoutAuditTrailQueryKey(options),
  });

export const eftAutoPaymentListQueryKey = (options: Options<EftAutoPaymentListData>) =>
  createQueryKey('eftAutoPaymentList', options);

/**
 * List Automated EFT Payments
 *
 * Retrieve the venue's automated EFT payment history, filterable by period, stage (queued, paused, transferring, paid, failed or cancelled) and payout reference.
 */
export const eftAutoPaymentListOptions = (options: Options<EftAutoPaymentListData>) =>
  queryOptions<
    EftAutoPaymentListResponse,
    EftAutoPaymentListError,
    EftAutoPaymentListResponse,
    ReturnType<typeof eftAutoPaymentListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await eftAutoPaymentList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: eftAutoPaymentListQueryKey(options),
  });

export const eftAutoPaymentListInfiniteQueryKey = (
  options: Options<EftAutoPaymentListData>,
): QueryKey<Options<EftAutoPaymentListData>> => createQueryKey('eftAutoPaymentList', options, true);

/**
 * List Automated EFT Payments
 *
 * Retrieve the venue's automated EFT payment history, filterable by period, stage (queued, paused, transferring, paid, failed or cancelled) and payout reference.
 */
export const eftAutoPaymentListInfiniteOptions = (options: Options<EftAutoPaymentListData>) => {
  const opts = infiniteQueryOptions<
    EftAutoPaymentListResponse,
    EftAutoPaymentListError,
    InfiniteData<EftAutoPaymentListResponse>,
    QueryKey<Options<EftAutoPaymentListData>>,
    | string
    | Pick<QueryKey<Options<EftAutoPaymentListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<EftAutoPaymentListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await eftAutoPaymentList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: eftAutoPaymentListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const ppVenueUserListQueryKey = (options: Options<PpVenueUserListData>) =>
  createQueryKey('ppVenueUserList', options);

/**
 * List Checkd venue users
 *
 * Retrieve paginated list of users for venue
 */
export const ppVenueUserListOptions = (options: Options<PpVenueUserListData>) =>
  queryOptions<
    PpVenueUserListResponse,
    PpVenueUserListError,
    PpVenueUserListResponse,
    ReturnType<typeof ppVenueUserListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ppVenueUserList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ppVenueUserListQueryKey(options),
  });

export const ppVenueUserListInfiniteQueryKey = (
  options: Options<PpVenueUserListData>,
): QueryKey<Options<PpVenueUserListData>> => createQueryKey('ppVenueUserList', options, true);

/**
 * List Checkd venue users
 *
 * Retrieve paginated list of users for venue
 */
export const ppVenueUserListInfiniteOptions = (options: Options<PpVenueUserListData>) => {
  const opts = infiniteQueryOptions<
    PpVenueUserListResponse,
    PpVenueUserListError,
    InfiniteData<PpVenueUserListResponse>,
    QueryKey<Options<PpVenueUserListData>>,
    string | Pick<QueryKey<Options<PpVenueUserListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PpVenueUserListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ppVenueUserList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: ppVenueUserListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * User Check PIN
 *
 * Check users PIN
 */
export const userPinCheckMutation = (
  options?: Partial<Options<UserPinCheckData>>,
): UseMutationOptions<UserPinCheckResponse2, UserPinCheckError, Options<UserPinCheckData>> => {
  const mutationOptions: UseMutationOptions<
    UserPinCheckResponse2,
    UserPinCheckError,
    Options<UserPinCheckData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userPinCheck({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a user association
 *
 * Remove a user from a venue
 */
export const ppVenueUserDeleteMutation = (
  options?: Partial<Options<PpVenueUserDeleteData>>,
): UseMutationOptions<
  PpVenueUserDeleteResponse,
  PpVenueUserDeleteError,
  Options<PpVenueUserDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    PpVenueUserDeleteResponse,
    PpVenueUserDeleteError,
    Options<PpVenueUserDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ppVenueUserDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const ppVenueUserGetQueryKey = (options: Options<PpVenueUserGetData>) =>
  createQueryKey('ppVenueUserGet', options);

/**
 * Get venue user
 *
 * Retrieve paginated list of users for venue
 */
export const ppVenueUserGetOptions = (options: Options<PpVenueUserGetData>) =>
  queryOptions<
    PpVenueUserGetResponse,
    PpVenueUserGetError,
    PpVenueUserGetResponse,
    ReturnType<typeof ppVenueUserGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ppVenueUserGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ppVenueUserGetQueryKey(options),
  });

/**
 * Associate a user
 *
 * Associate a user with a Checkd venue
 */
export const ppVenueUserCreateMutation = (
  options?: Partial<Options<PpVenueUserCreateData>>,
): UseMutationOptions<
  PpVenueUserCreateResponse,
  PpVenueUserCreateError,
  Options<PpVenueUserCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    PpVenueUserCreateResponse,
    PpVenueUserCreateError,
    Options<PpVenueUserCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ppVenueUserCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a user association
 *
 * Update an existing user's association with a checkd venue
 */
export const ppVenueUserUpdateMutation = (
  options?: Partial<Options<PpVenueUserUpdateData>>,
): UseMutationOptions<
  PpVenueUserUpdateResponse,
  PpVenueUserUpdateError,
  Options<PpVenueUserUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PpVenueUserUpdateResponse,
    PpVenueUserUpdateError,
    Options<PpVenueUserUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ppVenueUserUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const pokieVenueSettingRiskRuleListQueryKey = (
  options: Options<PokieVenueSettingRiskRuleListData>,
) => createQueryKey('pokieVenueSettingRiskRuleList', options);

/**
 * List risk rule metadata for Checkd venue settings
 *
 * List the risk rules shown in Checkd venue settings.
 */
export const pokieVenueSettingRiskRuleListOptions = (
  options: Options<PokieVenueSettingRiskRuleListData>,
) =>
  queryOptions<
    PokieVenueSettingRiskRuleListResponse,
    PokieVenueSettingRiskRuleListError,
    PokieVenueSettingRiskRuleListResponse,
    ReturnType<typeof pokieVenueSettingRiskRuleListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pokieVenueSettingRiskRuleList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: pokieVenueSettingRiskRuleListQueryKey(options),
  });

export const pokieVenueSettingGetQueryKey = (options: Options<PokieVenueSettingGetData>) =>
  createQueryKey('pokieVenueSettingGet', options);

/**
 * Get Venue Settings for Checkd
 *
 * Get Venue Settings for Checkd
 */
export const pokieVenueSettingGetOptions = (options: Options<PokieVenueSettingGetData>) =>
  queryOptions<
    PokieVenueSettingGetResponse,
    PokieVenueSettingGetError,
    PokieVenueSettingGetResponse,
    ReturnType<typeof pokieVenueSettingGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pokieVenueSettingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: pokieVenueSettingGetQueryKey(options),
  });

/**
 * Update Venue Payout Settings
 *
 * Update venue-specific settings for payout processing
 */
export const pokieVenueSettingUpdateMutation = (
  options?: Partial<Options<PokieVenueSettingUpdateData>>,
): UseMutationOptions<
  PokieVenueSettingUpdateResponse,
  PokieVenueSettingUpdateError,
  Options<PokieVenueSettingUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PokieVenueSettingUpdateResponse,
    PokieVenueSettingUpdateError,
    Options<PokieVenueSettingUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await pokieVenueSettingUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const voiSettingGetQueryKey = (options: Options<VoiSettingGetData>) =>
  createQueryKey('voiSettingGet', options);

/**
 * Get Venue VoI Setting
 *
 * Returns the secondary Verification of Identity check configuration for a venue. If no configuration has been saved, a default simple check with no allowed documents is returned.
 */
export const voiSettingGetOptions = (options: Options<VoiSettingGetData>) =>
  queryOptions<
    VoiSettingGetResponse,
    VoiSettingGetError,
    VoiSettingGetResponse,
    ReturnType<typeof voiSettingGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await voiSettingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: voiSettingGetQueryKey(options),
  });

/**
 * Update Venue VoI Setting
 *
 * Replaces the secondary VoI check configuration for a venue. The document list is always a full replacement — omitted documents are removed.
 */
export const voiSettingUpdateMutation = (
  options?: Partial<Options<VoiSettingUpdateData>>,
): UseMutationOptions<
  VoiSettingUpdateResponse,
  VoiSettingUpdateError,
  Options<VoiSettingUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    VoiSettingUpdateResponse,
    VoiSettingUpdateError,
    Options<VoiSettingUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await voiSettingUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const checkdDashboardMetricsQueryKey = (options: Options<CheckdDashboardMetricsData>) =>
  createQueryKey('checkdDashboardMetrics', options);

/**
 * Get Checkd Dashboard Metrics
 *
 * Get Checkd Dashboard Metrics
 */
export const checkdDashboardMetricsOptions = (options: Options<CheckdDashboardMetricsData>) =>
  queryOptions<
    CheckdDashboardMetricsResponse,
    CheckdDashboardMetricsError,
    CheckdDashboardMetricsResponse,
    ReturnType<typeof checkdDashboardMetricsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkdDashboardMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: checkdDashboardMetricsQueryKey(options),
  });

export const checkdAutoEftDashboardQueryKey = (options: Options<CheckdAutoEftDashboardData>) =>
  createQueryKey('checkdAutoEftDashboard', options);

/**
 * Get Automated EFT Dashboard Summary
 *
 * Payments due to leave the venue's account within a rolling 24 hours, and the venue's automated EFT exceptions — each counted, with the first five listed.
 */
export const checkdAutoEftDashboardOptions = (options: Options<CheckdAutoEftDashboardData>) =>
  queryOptions<
    CheckdAutoEftDashboardResponse,
    CheckdAutoEftDashboardError,
    CheckdAutoEftDashboardResponse,
    ReturnType<typeof checkdAutoEftDashboardQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkdAutoEftDashboard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: checkdAutoEftDashboardQueryKey(options),
  });

/**
 * Rank the people at the active venue who resemble a capture
 *
 * Match scanned or typed identity details against the people created at the active venue, most similar first, with how closely each of their details matched.
 */
export const patronSearchMutation = (
  options?: Partial<Options<PatronSearchData>>,
): UseMutationOptions<PatronSearchResponse, PatronSearchError, Options<PatronSearchData>> => {
  const mutationOptions: UseMutationOptions<
    PatronSearchResponse,
    PatronSearchError,
    Options<PatronSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronSearch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Compare a capture with a person's recorded details
 *
 * Before a capture is confirmed against a person created at the active venue, list each name, date of birth or phone that both hold and that differs. An offer is audited when any differs. Nothing is written to the person.
 */
export const patronCaptureCompareMutation = (
  options?: Partial<Options<PatronCaptureCompareData>>,
): UseMutationOptions<
  PatronCaptureCompareResponse,
  PatronCaptureCompareError,
  Options<PatronCaptureCompareData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronCaptureCompareResponse,
    PatronCaptureCompareError,
    Options<PatronCaptureCompareData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronCaptureCompare({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add a capture to an existing person
 *
 * Confirm a capture as a person created at the active venue, adding any detail or document their record lacks. A recorded detail is replaced only by a `detailsDecision` of `updated`, for the ticked details offered by the comparison; a bundle that sends no decision keeps the fill-gaps behaviour.
 */
export const patronCaptureAddMutation = (
  options?: Partial<Options<PatronCaptureAddData>>,
): UseMutationOptions<
  PatronCaptureAddResponse,
  PatronCaptureAddError,
  Options<PatronCaptureAddData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronCaptureAddResponse,
    PatronCaptureAddError,
    Options<PatronCaptureAddData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronCaptureAdd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set a person's patron type
 *
 * Record whether a person created at the active venue is a patron, an employee or a contractor.
 */
export const patronTypeUpdateMutation = (
  options?: Partial<Options<PatronTypeUpdateData>>,
): UseMutationOptions<
  PatronTypeUpdateResponse,
  PatronTypeUpdateError,
  Options<PatronTypeUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronTypeUpdateResponse,
    PatronTypeUpdateError,
    Options<PatronTypeUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronTypeUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Correct a person's details
 *
 * Replace the names, date of birth or phone of a person created at the active venue. First name, family name and date of birth cannot be cleared. Each change is audited with masked values. Identity documents are not editable.
 */
export const patronDetailsUpdateMutation = (
  options?: Partial<Options<PatronDetailsUpdateData>>,
): UseMutationOptions<
  PatronDetailsUpdateResponse,
  PatronDetailsUpdateError,
  Options<PatronDetailsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronDetailsUpdateResponse,
    PatronDetailsUpdateError,
    Options<PatronDetailsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronDetailsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const patronAuditTrailQueryKey = (options: Options<PatronAuditTrailData>) =>
  createQueryKey('patronAuditTrail', options);

/**
 * Read a person's audit trail
 *
 * What happened to and with a person created at the active venue, newest first, read from the audit sink one page at a time. Changed values are masked.
 */
export const patronAuditTrailOptions = (options: Options<PatronAuditTrailData>) =>
  queryOptions<
    PatronAuditTrailResponse,
    PatronAuditTrailError,
    PatronAuditTrailResponse,
    ReturnType<typeof patronAuditTrailQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await patronAuditTrail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: patronAuditTrailQueryKey(options),
  });

/**
 * Decide the result of a PEP, sanctions and adverse media check
 *
 * Confirm which of a check's candidates the person is, or that none of them is. Only the person's newest check can be decided, and only once.
 */
export const patronPepCheckDecideMutation = (
  options?: Partial<Options<PatronPepCheckDecideData>>,
): UseMutationOptions<
  PatronPepCheckDecideResponse,
  PatronPepCheckDecideError,
  Options<PatronPepCheckDecideData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronPepCheckDecideResponse,
    PatronPepCheckDecideError,
    Options<PatronPepCheckDecideData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronPepCheckDecide({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Run a PEP, sanctions and adverse media check on a person
 *
 * Screen a person created at the active venue against the provider now, outside any payout. Always a fresh provider call.
 */
export const patronPepCheckRunMutation = (
  options?: Partial<Options<PatronPepCheckRunData>>,
): UseMutationOptions<
  PatronPepCheckRunResponse,
  PatronPepCheckRunError,
  Options<PatronPepCheckRunData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronPepCheckRunResponse,
    PatronPepCheckRunError,
    Options<PatronPepCheckRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronPepCheckRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify a scan of a person's ID with DVS
 *
 * Check a freshly scanned ID of a person created at the active venue with the issuing authority, outside any payout. The scan's names and date of birth must be the person's.
 */
export const patronDvsCheckRunMutation = (
  options?: Partial<Options<PatronDvsCheckRunData>>,
): UseMutationOptions<
  PatronDvsCheckRunResponse,
  PatronDvsCheckRunError,
  Options<PatronDvsCheckRunData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronDvsCheckRunResponse,
    PatronDvsCheckRunError,
    Options<PatronDvsCheckRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronDvsCheckRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify a person's digital licence
 *
 * Verify a QLD or VIC digital licence of a person created at the active venue, and record it as their identity check. The licence's name and date of birth must be the person's.
 */
export const patronIdentityCheckDigitalMutation = (
  options?: Partial<Options<PatronIdentityCheckDigitalData>>,
): UseMutationOptions<
  PatronIdentityCheckDigitalResponse,
  PatronIdentityCheckDigitalError,
  Options<PatronIdentityCheckDigitalData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronIdentityCheckDigitalResponse,
    PatronIdentityCheckDigitalError,
    Options<PatronIdentityCheckDigitalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronIdentityCheckDigital({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Attach a Check a Person digital licence check to the person recorded
 *
 * Attach the caller's own Check a Person digital licence check, scanned within the last 15 minutes, to the person it names. A check is attached once.
 */
export const patronIdentityCheckAttachMutation = (
  options?: Partial<Options<PatronIdentityCheckAttachData>>,
): UseMutationOptions<
  PatronIdentityCheckAttachResponse,
  PatronIdentityCheckAttachError,
  Options<PatronIdentityCheckAttachData>
> => {
  const mutationOptions: UseMutationOptions<
    PatronIdentityCheckAttachResponse,
    PatronIdentityCheckAttachError,
    Options<PatronIdentityCheckAttachData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronIdentityCheckAttach({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Verify a digital licence on Check a Person
 *
 * Verify a QLD or VIC digital licence before the person is recorded. The check is held for the scanning user to attach to the person they record, within 15 minutes.
 */
export const adhocIdentityCheckDigitalMutation = (
  options?: Partial<Options<AdhocIdentityCheckDigitalData>>,
): UseMutationOptions<
  AdhocIdentityCheckDigitalResponse,
  AdhocIdentityCheckDigitalError,
  Options<AdhocIdentityCheckDigitalData>
> => {
  const mutationOptions: UseMutationOptions<
    AdhocIdentityCheckDigitalResponse,
    AdhocIdentityCheckDigitalError,
    Options<AdhocIdentityCheckDigitalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await adhocIdentityCheckDigital({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const patronGetQueryKey = (options: Options<PatronGetData>) =>
  createQueryKey('patronGet', options);

/**
 * Get a person with their screening history
 *
 * Retrieve one person created at the active venue, with the verdict standing against them and every screening check run against them.
 */
export const patronGetOptions = (options: Options<PatronGetData>) =>
  queryOptions<
    PatronGetResponse,
    PatronGetError,
    PatronGetResponse,
    ReturnType<typeof patronGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await patronGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: patronGetQueryKey(options),
  });

export const patronListQueryKey = (options: Options<PatronListData>) =>
  createQueryKey('patronList', options);

/**
 * List people known to the venue
 *
 * Retrieve paginated people created at the active venue, each with the screening verdict currently standing against them.
 */
export const patronListOptions = (options: Options<PatronListData>) =>
  queryOptions<
    PatronListResponse,
    PatronListError,
    PatronListResponse,
    ReturnType<typeof patronListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await patronList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: patronListQueryKey(options),
  });

export const patronListInfiniteQueryKey = (
  options: Options<PatronListData>,
): QueryKey<Options<PatronListData>> => createQueryKey('patronList', options, true);

/**
 * List people known to the venue
 *
 * Retrieve paginated people created at the active venue, each with the screening verdict currently standing against them.
 */
export const patronListInfiniteOptions = (options: Options<PatronListData>) => {
  const opts = infiniteQueryOptions<
    PatronListResponse,
    PatronListError,
    InfiniteData<PatronListResponse>,
    QueryKey<Options<PatronListData>>,
    string | Pick<QueryKey<Options<PatronListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PatronListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await patronList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: patronListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Record a new person at the active venue
 *
 * Create a person from captured identity details, with their document when one was captured.
 */
export const patronCreateMutation = (
  options?: Partial<Options<PatronCreateData>>,
): UseMutationOptions<PatronCreateResponse, PatronCreateError, Options<PatronCreateData>> => {
  const mutationOptions: UseMutationOptions<
    PatronCreateResponse,
    PatronCreateError,
    Options<PatronCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await patronCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const riskRegisterMetricsQueryKey = (options: Options<RiskRegisterMetricsData>) =>
  createQueryKey('riskRegisterMetrics', options);

/**
 * Get AML risk register metrics
 *
 * Get AML risk register metrics for the active venue.
 */
export const riskRegisterMetricsOptions = (options: Options<RiskRegisterMetricsData>) =>
  queryOptions<
    RiskRegisterMetricsResponse,
    RiskRegisterMetricsError,
    RiskRegisterMetricsResponse,
    ReturnType<typeof riskRegisterMetricsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await riskRegisterMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: riskRegisterMetricsQueryKey(options),
  });

export const riskRegisterPatronSearchQueryKey = (options: Options<RiskRegisterPatronSearchData>) =>
  createQueryKey('riskRegisterPatronSearch', options);

/**
 * Search patrons for a manual AML risk
 *
 * Name search over the venue's patrons, to associate a manual risk with an existing patron.
 */
export const riskRegisterPatronSearchOptions = (options: Options<RiskRegisterPatronSearchData>) =>
  queryOptions<
    RiskRegisterPatronSearchResponse,
    RiskRegisterPatronSearchError,
    RiskRegisterPatronSearchResponse,
    ReturnType<typeof riskRegisterPatronSearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await riskRegisterPatronSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: riskRegisterPatronSearchQueryKey(options),
  });

export const riskRegisterPayoutSearchQueryKey = (options: Options<RiskRegisterPayoutSearchData>) =>
  createQueryKey('riskRegisterPayoutSearch', options);

/**
 * Search payouts to link to a manual AML risk
 *
 * Search the venue's payouts by external id, patron name, or a whole-dollar amount that starts with the query.
 */
export const riskRegisterPayoutSearchOptions = (options: Options<RiskRegisterPayoutSearchData>) =>
  queryOptions<
    RiskRegisterPayoutSearchResponse,
    RiskRegisterPayoutSearchError,
    RiskRegisterPayoutSearchResponse,
    ReturnType<typeof riskRegisterPayoutSearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await riskRegisterPayoutSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: riskRegisterPayoutSearchQueryKey(options),
  });

/**
 * Review an AML risk register item
 *
 * Persist a manager AML risk review decision for a risk register entry.
 */
export const riskRegisterReviewMutation = (
  options?: Partial<Options<RiskRegisterReviewData>>,
): UseMutationOptions<
  RiskRegisterReviewResponse,
  RiskRegisterReviewError,
  Options<RiskRegisterReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    RiskRegisterReviewResponse,
    RiskRegisterReviewError,
    Options<RiskRegisterReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await riskRegisterReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a supporting document from a risk register item
 *
 * Delete a supporting document attached to a payout risk register item.
 */
export const riskRegisterAttachmentDeleteMutation = (
  options?: Partial<Options<RiskRegisterAttachmentDeleteData>>,
): UseMutationOptions<
  RiskRegisterAttachmentDeleteResponse,
  RiskRegisterAttachmentDeleteError,
  Options<RiskRegisterAttachmentDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    RiskRegisterAttachmentDeleteResponse,
    RiskRegisterAttachmentDeleteError,
    Options<RiskRegisterAttachmentDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await riskRegisterAttachmentDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const riskRegisterAttachmentGetQueryKey = (
  options: Options<RiskRegisterAttachmentGetData>,
) => createQueryKey('riskRegisterAttachmentGet', options);

/**
 * List supporting documents for a risk register item
 *
 * Retrieve the supporting documents attached to a payout risk register item.
 */
export const riskRegisterAttachmentGetOptions = (options: Options<RiskRegisterAttachmentGetData>) =>
  queryOptions<
    RiskRegisterAttachmentGetResponse,
    RiskRegisterAttachmentGetError,
    RiskRegisterAttachmentGetResponse,
    ReturnType<typeof riskRegisterAttachmentGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await riskRegisterAttachmentGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: riskRegisterAttachmentGetQueryKey(options),
  });

/**
 * Attach a supporting document to a risk register item
 *
 * Associate an uploaded file with a payout risk register item as a supporting document. Available both during and after the manager review.
 */
export const riskRegisterAttachmentCreateMutation = (
  options?: Partial<Options<RiskRegisterAttachmentCreateData>>,
): UseMutationOptions<
  RiskRegisterAttachmentCreateResponse,
  RiskRegisterAttachmentCreateError,
  Options<RiskRegisterAttachmentCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    RiskRegisterAttachmentCreateResponse,
    RiskRegisterAttachmentCreateError,
    Options<RiskRegisterAttachmentCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await riskRegisterAttachmentCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const riskRegisterListQueryKey = (options: Options<RiskRegisterListData>) =>
  createQueryKey('riskRegisterList', options);

/**
 * List AML risk register items
 *
 * Retrieve paginated AML risk register items for the active venue.
 */
export const riskRegisterListOptions = (options: Options<RiskRegisterListData>) =>
  queryOptions<
    RiskRegisterListResponse,
    RiskRegisterListError,
    RiskRegisterListResponse,
    ReturnType<typeof riskRegisterListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await riskRegisterList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: riskRegisterListQueryKey(options),
  });

export const riskRegisterListInfiniteQueryKey = (
  options: Options<RiskRegisterListData>,
): QueryKey<Options<RiskRegisterListData>> => createQueryKey('riskRegisterList', options, true);

/**
 * List AML risk register items
 *
 * Retrieve paginated AML risk register items for the active venue.
 */
export const riskRegisterListInfiniteOptions = (options: Options<RiskRegisterListData>) => {
  const opts = infiniteQueryOptions<
    RiskRegisterListResponse,
    RiskRegisterListError,
    InfiniteData<RiskRegisterListResponse>,
    QueryKey<Options<RiskRegisterListData>>,
    string | Pick<QueryKey<Options<RiskRegisterListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<RiskRegisterListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await riskRegisterList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: riskRegisterListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create a manual AML risk register entry
 *
 * Register a manually-identified AML risk. Optionally include a review payload to action it in the same request; otherwise it is registered as awaiting review.
 */
export const riskRegisterCreateMutation = (
  options?: Partial<Options<RiskRegisterCreateData>>,
): UseMutationOptions<
  RiskRegisterCreateResponse,
  RiskRegisterCreateError,
  Options<RiskRegisterCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    RiskRegisterCreateResponse,
    RiskRegisterCreateError,
    Options<RiskRegisterCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await riskRegisterCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Checkd application invitation
 *
 * Invite a user by email to join the venue with a specific role for checkd application
 */
export const ppUserInviteMutation = (
  options?: Partial<Options<PpUserInviteData>>,
): UseMutationOptions<PpUserInviteResponse, PpUserInviteError, Options<PpUserInviteData>> => {
  const mutationOptions: UseMutationOptions<
    PpUserInviteResponse,
    PpUserInviteError,
    Options<PpUserInviteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ppUserInvite({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Checkd application reinvitation
 *
 * Reinvite a user by email to join the venue with a specific role for checkd application
 */
export const ppUserReinviteMutation = (
  options?: Partial<Options<PpUserReinviteData>>,
): UseMutationOptions<PpUserReinviteResponse, PpUserReinviteError, Options<PpUserReinviteData>> => {
  const mutationOptions: UseMutationOptions<
    PpUserReinviteResponse,
    PpUserReinviteError,
    Options<PpUserReinviteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ppUserReinvite({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Checkd application revoke invitation
 *
 * Revoke a user invite to join the venue with a specific role for checkd application
 */
export const ppUserRevokeInviteMutation = (
  options?: Partial<Options<PpUserRevokeInviteData>>,
): UseMutationOptions<
  PpUserRevokeInviteResponse,
  PpUserRevokeInviteError,
  Options<PpUserRevokeInviteData>
> => {
  const mutationOptions: UseMutationOptions<
    PpUserRevokeInviteResponse,
    PpUserRevokeInviteError,
    Options<PpUserRevokeInviteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ppUserRevokeInvite({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const permissionCatalogueListQueryKey = (options: Options<PermissionCatalogueListData>) =>
  createQueryKey('permissionCatalogueList', options);

/**
 * List Permission Catalogue
 *
 * The application’s declared permissions with their titles. Venue-membership gated on purpose (contract, api-surface.md): the catalogue is static capability names, carrying no venue or user data
 */
export const permissionCatalogueListOptions = (options: Options<PermissionCatalogueListData>) =>
  queryOptions<
    PermissionCatalogueListResponse,
    PermissionCatalogueListError,
    PermissionCatalogueListResponse,
    ReturnType<typeof permissionCatalogueListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await permissionCatalogueList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: permissionCatalogueListQueryKey(options),
  });

export const venueAssignableRoleListQueryKey = (options: Options<VenueAssignableRoleListData>) =>
  createQueryKey('venueAssignableRoleList', options);

/**
 * List the venue-application's roles
 *
 * Every role that exists at this venue and application, with its help text, for the surfaces that offer a role. There is no offered or hidden state — a role exists or it was deleted.
 */
export const venueAssignableRoleListOptions = (options: Options<VenueAssignableRoleListData>) =>
  queryOptions<
    VenueAssignableRoleListResponse,
    VenueAssignableRoleListError,
    VenueAssignableRoleListResponse,
    ReturnType<typeof venueAssignableRoleListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await venueAssignableRoleList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: venueAssignableRoleListQueryKey(options),
  });

/**
 * Update Venue Role Permissions
 *
 * Save the permissions of several roles at once, as the roles grid does. Applied in one transaction, so a refusal on any role leaves every role unchanged
 */
export const venueRolePermissionsUpdateMutation = (
  options?: Partial<Options<VenueRolePermissionsUpdateData>>,
): UseMutationOptions<
  VenueRolePermissionsUpdateResponse,
  VenueRolePermissionsUpdateError,
  Options<VenueRolePermissionsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    VenueRolePermissionsUpdateResponse,
    VenueRolePermissionsUpdateError,
    Options<VenueRolePermissionsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await venueRolePermissionsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const venueRoleListQueryKey = (options: Options<VenueRoleListData>) =>
  createQueryKey('venueRoleList', options);

/**
 * List Venue Roles
 *
 * Every role that exists at the caller's venue-application, with its permissions, help text and holder count
 */
export const venueRoleListOptions = (options: Options<VenueRoleListData>) =>
  queryOptions<
    VenueRoleListResponse2,
    VenueRoleListError,
    VenueRoleListResponse2,
    ReturnType<typeof venueRoleListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await venueRoleList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: venueRoleListQueryKey(options),
  });

/**
 * Create Venue Role
 *
 * Create a role at the caller’s venue-application. There is no grant ceiling: any catalogue permission may be granted (FR-014)
 */
export const venueRoleCreateMutation = (
  options?: Partial<Options<VenueRoleCreateData>>,
): UseMutationOptions<
  VenueRoleCreateResponse,
  VenueRoleCreateError,
  Options<VenueRoleCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    VenueRoleCreateResponse,
    VenueRoleCreateError,
    Options<VenueRoleCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await venueRoleCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Venue Role
 *
 * Delete a role nobody holds. A held role is refused, stating the count (FR-018)
 */
export const venueRoleDeleteMutation = (
  options?: Partial<Options<VenueRoleDeleteData>>,
): UseMutationOptions<
  VenueRoleDeleteResponse,
  VenueRoleDeleteError,
  Options<VenueRoleDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    VenueRoleDeleteResponse,
    VenueRoleDeleteError,
    Options<VenueRoleDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await venueRoleDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const venueRoleGetQueryKey = (options: Options<VenueRoleGetData>) =>
  createQueryKey('venueRoleGet', options);

/**
 * Get Venue Role
 *
 * One role of the caller’s venue-application, with its permissions and holders
 */
export const venueRoleGetOptions = (options: Options<VenueRoleGetData>) =>
  queryOptions<
    VenueRoleGetResponse,
    VenueRoleGetError,
    VenueRoleGetResponse,
    ReturnType<typeof venueRoleGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await venueRoleGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: venueRoleGetQueryKey(options),
  });

/**
 * Update Venue Role
 *
 * Rename a role, reword its help text, or change the permissions it grants
 */
export const venueRoleUpdateMutation = (
  options?: Partial<Options<VenueRoleUpdateData>>,
): UseMutationOptions<
  VenueRoleUpdateResponse,
  VenueRoleUpdateError,
  Options<VenueRoleUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    VenueRoleUpdateResponse,
    VenueRoleUpdateError,
    Options<VenueRoleUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await venueRoleUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduAutoEftMetricsQueryKey = (options: Options<IduAutoEftMetricsData>) =>
  createQueryKey('iduAutoEftMetrics', options);

/**
 * Automated EFT metrics, exception cohorts and sweep health across every venue
 *
 * iDU-admin-only, any venue. Aggregate volumes and success/failure rates for a period, failures broken down by reason with an explicit reason_not_reported bucket, counts for every exception cohort, sweep health separating a missed sweep from a quiet period and from venue ineligibility, and the paginated drill-through behind an aggregate figure. The period is matched on eligibleAt, so a failure that never reached submission is counted.
 */
export const iduAutoEftMetricsOptions = (options: Options<IduAutoEftMetricsData>) =>
  queryOptions<
    IduAutoEftMetricsResponse,
    IduAutoEftMetricsError,
    IduAutoEftMetricsResponse,
    ReturnType<typeof iduAutoEftMetricsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduAutoEftMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduAutoEftMetricsQueryKey(options),
  });

export const iduAutoEftMetricsInfiniteQueryKey = (
  options: Options<IduAutoEftMetricsData>,
): QueryKey<Options<IduAutoEftMetricsData>> => createQueryKey('iduAutoEftMetrics', options, true);

/**
 * Automated EFT metrics, exception cohorts and sweep health across every venue
 *
 * iDU-admin-only, any venue. Aggregate volumes and success/failure rates for a period, failures broken down by reason with an explicit reason_not_reported bucket, counts for every exception cohort, sweep health separating a missed sweep from a quiet period and from venue ineligibility, and the paginated drill-through behind an aggregate figure. The period is matched on eligibleAt, so a failure that never reached submission is counted.
 */
export const iduAutoEftMetricsInfiniteOptions = (options: Options<IduAutoEftMetricsData>) => {
  const opts = infiniteQueryOptions<
    IduAutoEftMetricsResponse,
    IduAutoEftMetricsError,
    InfiniteData<IduAutoEftMetricsResponse>,
    QueryKey<Options<IduAutoEftMetricsData>>,
    | string
    | Pick<QueryKey<Options<IduAutoEftMetricsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduAutoEftMetricsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduAutoEftMetrics({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduAutoEftMetricsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduAutoEftRecordsQueryKey = (options?: Options<IduAutoEftRecordsData>) =>
  createQueryKey('iduAutoEftRecords', options);

/**
 * Browse every automated EFT payment across the estate
 *
 * iDU-admin-only, any venue, read-only. Lists automated EFT payments in every state — not only exceptions — with optional filters on status, cohort, venue and payout reference. No period is required and none is applied: the estate is browsed in full. Every row reports the cohort it classifies into, so a record can be read without filtering by cohort. A cohort filter cannot be expressed in SQL, so those requests are classified over a bounded scan and paginated afterwards; `scan.truncated` reports when the scan hit its cap.
 */
export const iduAutoEftRecordsOptions = (options?: Options<IduAutoEftRecordsData>) =>
  queryOptions<
    IduAutoEftRecordsResponse,
    IduAutoEftRecordsError,
    IduAutoEftRecordsResponse,
    ReturnType<typeof iduAutoEftRecordsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduAutoEftRecords({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduAutoEftRecordsQueryKey(options),
  });

export const iduAutoEftRecordsInfiniteQueryKey = (
  options?: Options<IduAutoEftRecordsData>,
): QueryKey<Options<IduAutoEftRecordsData>> => createQueryKey('iduAutoEftRecords', options, true);

/**
 * Browse every automated EFT payment across the estate
 *
 * iDU-admin-only, any venue, read-only. Lists automated EFT payments in every state — not only exceptions — with optional filters on status, cohort, venue and payout reference. No period is required and none is applied: the estate is browsed in full. Every row reports the cohort it classifies into, so a record can be read without filtering by cohort. A cohort filter cannot be expressed in SQL, so those requests are classified over a bounded scan and paginated afterwards; `scan.truncated` reports when the scan hit its cap.
 */
export const iduAutoEftRecordsInfiniteOptions = (options?: Options<IduAutoEftRecordsData>) => {
  const opts = infiniteQueryOptions<
    IduAutoEftRecordsResponse,
    IduAutoEftRecordsError,
    InfiniteData<IduAutoEftRecordsResponse>,
    QueryKey<Options<IduAutoEftRecordsData>>,
    | string
    | Pick<QueryKey<Options<IduAutoEftRecordsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduAutoEftRecordsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduAutoEftRecords({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduAutoEftRecordsInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduAutoEftMerchantWarriorCheckQueryKey = (
  options: Options<IduAutoEftMerchantWarriorCheckData>,
) => createQueryKey('iduAutoEftMerchantWarriorCheck', options);

/**
 * Check an automated EFT payment against Merchant Warrior
 *
 * iDU-admin-only, any venue. Asks the venue’s own Merchant Warrior account whether it holds a payout batch for this payment, so staff can confirm no money moved before deciding whether to pay again. Read-only: nothing is written, retried or repaired. The identifier asked under is reported — Merchant Warrior’s payout id, the stored submission reference, or the deterministic reference the payment would have carried, in that order — so a record that died before storing anything is still answerable. `no_batch_found` is the assurance that nothing was submitted; `unconfirmed` means Merchant Warrior could not be asked and is explicitly NOT that assurance.
 */
export const iduAutoEftMerchantWarriorCheckOptions = (
  options: Options<IduAutoEftMerchantWarriorCheckData>,
) =>
  queryOptions<
    IduAutoEftMerchantWarriorCheckResponse,
    IduAutoEftMerchantWarriorCheckError,
    IduAutoEftMerchantWarriorCheckResponse,
    ReturnType<typeof iduAutoEftMerchantWarriorCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduAutoEftMerchantWarriorCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduAutoEftMerchantWarriorCheckQueryKey(options),
  });

/**
 * Record a staff resolution for an automated EFT payment
 *
 * iDU-admin-only, any venue. Records that iDU or Merchant Warrior resolved a failed or stuck automated EFT payment, so the venue-facing view shows it as resolved. The record keeps its status and its full failure history: the resolution is appended to the audit trail and the only column written is the marker the venue-facing view reads. Refused for any other status, including paid, and refused a second time for an already-resolved record.
 */
export const iduAutoEftResolutionRecordMutation = (
  options?: Partial<Options<IduAutoEftResolutionRecordData>>,
): UseMutationOptions<
  IduAutoEftResolutionRecordResponse,
  IduAutoEftResolutionRecordError,
  Options<IduAutoEftResolutionRecordData>
> => {
  const mutationOptions: UseMutationOptions<
    IduAutoEftResolutionRecordResponse,
    IduAutoEftResolutionRecordError,
    Options<IduAutoEftResolutionRecordData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduAutoEftResolutionRecord({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Mark an automated EFT payment retryable, for any venue
 *
 * iDU-admin-only, any venue. Returns a payment_failed record to scheduled so the next sweep can pick it up — the same service call Checkd managers make for their own venue, at a wider reach. The venue is read from the record, never supplied by the caller. Refused for any status other than payment_failed.
 */
export const iduAutoEftRetryableMutation = (
  options?: Partial<Options<IduAutoEftRetryableData>>,
): UseMutationOptions<
  IduAutoEftRetryableResponse,
  IduAutoEftRetryableError,
  Options<IduAutoEftRetryableData>
> => {
  const mutationOptions: UseMutationOptions<
    IduAutoEftRetryableResponse,
    IduAutoEftRetryableError,
    Options<IduAutoEftRetryableData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduAutoEftRetryable({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduDashboardMetricsQueryKey = (options?: Options<IduDashboardMetricsData>) =>
  createQueryKey('iduDashboardMetrics', options);

/**
 * Get dashboard metrics for Checkd
 *
 * Get top venues sorted by longest time since last payout (admin dashboard)
 */
export const iduDashboardMetricsOptions = (options?: Options<IduDashboardMetricsData>) =>
  queryOptions<
    IduDashboardMetricsResponse,
    IduDashboardMetricsError,
    IduDashboardMetricsResponse,
    ReturnType<typeof iduDashboardMetricsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduDashboardMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduDashboardMetricsQueryKey(options),
  });

export const iduDashboardCheckdMetricsQueryKey = (
  options?: Options<IduDashboardCheckdMetricsData>,
) => createQueryKey('iduDashboardCheckdMetrics', options);

/**
 * Get global Checkd metrics for the admin dashboard
 *
 * Grand totals (all-time, plus last-30d per metric with 30d / 90d / all-time change indicators), aggregate payout stats over finalised payouts, payments split by tender type, and risk breakdown by suggested and manager risk level.
 */
export const iduDashboardCheckdMetricsOptions = (
  options?: Options<IduDashboardCheckdMetricsData>,
) =>
  queryOptions<
    IduDashboardCheckdMetricsResponse,
    IduDashboardCheckdMetricsError,
    IduDashboardCheckdMetricsResponse,
    ReturnType<typeof iduDashboardCheckdMetricsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduDashboardCheckdMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduDashboardCheckdMetricsQueryKey(options),
  });

export const iduDashboardCheckdVenueTablesQueryKey = (
  options?: Options<IduDashboardCheckdVenueTablesData>,
) => createQueryKey('iduDashboardCheckdVenueTables', options);

/**
 * Get Checkd venue league tables for the admin dashboard
 *
 * Top 10 venues with declining product usage and top 10 with the most discarded/rejected payouts, each with a 12-month sparkline.
 */
export const iduDashboardCheckdVenueTablesOptions = (
  options?: Options<IduDashboardCheckdVenueTablesData>,
) =>
  queryOptions<
    IduDashboardCheckdVenueTablesResponse,
    IduDashboardCheckdVenueTablesError,
    IduDashboardCheckdVenueTablesResponse,
    ReturnType<typeof iduDashboardCheckdVenueTablesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduDashboardCheckdVenueTables({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduDashboardCheckdVenueTablesQueryKey(options),
  });

export const iduDashboardCheckdVenueMetricsQueryKey = (
  options: Options<IduDashboardCheckdVenueMetricsData>,
) => createQueryKey('iduDashboardCheckdVenueMetrics', options);

/**
 * Get per-venue Checkd metrics for the admin dashboard
 *
 * Usage/value/experience metrics for a single venue: payout windows (30/90/all + all-venue average), stage timings, risk breakdown, confirmed BNDRY matches by category, hour-of-day distribution, and Confirmation of Payee coverage/outcomes.
 */
export const iduDashboardCheckdVenueMetricsOptions = (
  options: Options<IduDashboardCheckdVenueMetricsData>,
) =>
  queryOptions<
    IduDashboardCheckdVenueMetricsResponse,
    IduDashboardCheckdVenueMetricsError,
    IduDashboardCheckdVenueMetricsResponse,
    ReturnType<typeof iduDashboardCheckdVenueMetricsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduDashboardCheckdVenueMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduDashboardCheckdVenueMetricsQueryKey(options),
  });

export const iduDashboardCheckdPayoutListQueryKey = (
  options?: Options<IduDashboardCheckdPayoutListData>,
) => createQueryKey('iduDashboardCheckdPayoutList', options);

/**
 * List Checkd payouts for metric drill-downs
 *
 * Paginated payout list filtered by risk (suggested/manager level), venue, status, and Confirmation of Payee result. Used by the risk-breakdown and Confirmation of Payee drill-down links. Admin-only; excludes patron PII.
 */
export const iduDashboardCheckdPayoutListOptions = (
  options?: Options<IduDashboardCheckdPayoutListData>,
) =>
  queryOptions<
    IduDashboardCheckdPayoutListResponse,
    IduDashboardCheckdPayoutListError,
    IduDashboardCheckdPayoutListResponse,
    ReturnType<typeof iduDashboardCheckdPayoutListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduDashboardCheckdPayoutList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduDashboardCheckdPayoutListQueryKey(options),
  });

export const iduDashboardCheckdPayoutListInfiniteQueryKey = (
  options?: Options<IduDashboardCheckdPayoutListData>,
): QueryKey<Options<IduDashboardCheckdPayoutListData>> =>
  createQueryKey('iduDashboardCheckdPayoutList', options, true);

/**
 * List Checkd payouts for metric drill-downs
 *
 * Paginated payout list filtered by risk (suggested/manager level), venue, status, and Confirmation of Payee result. Used by the risk-breakdown and Confirmation of Payee drill-down links. Admin-only; excludes patron PII.
 */
export const iduDashboardCheckdPayoutListInfiniteOptions = (
  options?: Options<IduDashboardCheckdPayoutListData>,
) => {
  const opts = infiniteQueryOptions<
    IduDashboardCheckdPayoutListResponse,
    IduDashboardCheckdPayoutListError,
    InfiniteData<IduDashboardCheckdPayoutListResponse>,
    QueryKey<Options<IduDashboardCheckdPayoutListData>>,
    | string
    | Pick<
        QueryKey<Options<IduDashboardCheckdPayoutListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduDashboardCheckdPayoutListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduDashboardCheckdPayoutList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduDashboardCheckdPayoutListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduPayoutVenueMovePreviewQueryKey = (
  options: Options<IduPayoutVenueMovePreviewData>,
) => createQueryKey('iduPayoutVenueMovePreview', options);

/**
 * Preview moving a payout to another venue
 *
 * Reports what moving this payout would change — the reference it would take at the destination, what happens to the patron record, and anything that blocks the move. Read-only. Admin dashboard only.
 */
export const iduPayoutVenueMovePreviewOptions = (options: Options<IduPayoutVenueMovePreviewData>) =>
  queryOptions<
    IduPayoutVenueMovePreviewResponse,
    IduPayoutVenueMovePreviewError,
    IduPayoutVenueMovePreviewResponse,
    ReturnType<typeof iduPayoutVenueMovePreviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduPayoutVenueMovePreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduPayoutVenueMovePreviewQueryKey(options),
  });

/**
 * Move a payout to another venue
 *
 * Moves a payout raised against the wrong venue. Re-allocates the payout's reference number at the destination, re-points its risk-register and confirmation-of-payee rows, and moves or copies the patron record so the destination can still match them. Admin dashboard only.
 */
export const iduPayoutVenueMoveMutation = (
  options?: Partial<Options<IduPayoutVenueMoveData>>,
): UseMutationOptions<
  IduPayoutVenueMoveResponse,
  IduPayoutVenueMoveError,
  Options<IduPayoutVenueMoveData>
> => {
  const mutationOptions: UseMutationOptions<
    IduPayoutVenueMoveResponse,
    IduPayoutVenueMoveError,
    Options<IduPayoutVenueMoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduPayoutVenueMove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduPayoutAuditQueryKey = (options: Options<IduPayoutAuditData>) =>
  createQueryKey('iduPayoutAudit', options);

/**
 * Payout audit trail
 *
 * The payout's audit trail, in the same shape Checkd renders — so customer success sees the correction history where the correction is made. Admin dashboard only.
 */
export const iduPayoutAuditOptions = (options: Options<IduPayoutAuditData>) =>
  queryOptions<
    IduPayoutAuditResponse,
    IduPayoutAuditError,
    IduPayoutAuditResponse,
    ReturnType<typeof iduPayoutAuditQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduPayoutAudit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduPayoutAuditQueryKey(options),
  });

/**
 * Preview a customer-success payout correction
 *
 * Reports what applying the proposed changes would do — anything that blocks the correction, the downstream effects it would trigger, and a before/after diff. Read-only: nothing is written and nothing is logged. Admin dashboard only.
 */
export const iduPayoutCorrectionPreviewMutation = (
  options?: Partial<Options<IduPayoutCorrectionPreviewData>>,
): UseMutationOptions<
  IduPayoutCorrectionPreviewResponse,
  IduPayoutCorrectionPreviewError,
  Options<IduPayoutCorrectionPreviewData>
> => {
  const mutationOptions: UseMutationOptions<
    IduPayoutCorrectionPreviewResponse,
    IduPayoutCorrectionPreviewError,
    Options<IduPayoutCorrectionPreviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduPayoutCorrectionPreview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Correct a payout on behalf of a venue
 *
 * Applies a customer-success correction to the payment split, patron name or patron banking detail fields. Banking details are refused once the automated EFT payment is in flight or has paid. Re-evaluates the preview rules, refuses when the payout changed since it was loaded, and records the correction with its reason in the audit trail. Admin dashboard only.
 */
export const iduPayoutCorrectionMutation = (
  options?: Partial<Options<IduPayoutCorrectionData>>,
): UseMutationOptions<
  IduPayoutCorrectionResponse,
  IduPayoutCorrectionError,
  Options<IduPayoutCorrectionData>
> => {
  const mutationOptions: UseMutationOptions<
    IduPayoutCorrectionResponse,
    IduPayoutCorrectionError,
    Options<IduPayoutCorrectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduPayoutCorrection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduPayoutDetailQueryKey = (options: Options<IduPayoutDetailData>) =>
  createQueryKey('iduPayoutDetail', options);

/**
 * Payout detail with correctability
 *
 * Returns a payout with its patron name fields and what a customer-success correction may change on it. The updatedAt is echoed back on the correction endpoint for conflict detection. Admin dashboard only.
 */
export const iduPayoutDetailOptions = (options: Options<IduPayoutDetailData>) =>
  queryOptions<
    IduPayoutDetailResponse,
    IduPayoutDetailError,
    IduPayoutDetailResponse,
    ReturnType<typeof iduPayoutDetailQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduPayoutDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduPayoutDetailQueryKey(options),
  });

export const iduLogsListQueryKey = (options?: Options<IduLogsListData>) =>
  createQueryKey('iduLogsList', options);

/**
 * List logs
 *
 * List frontend and backend log entries for the admin dashboard.
 */
export const iduLogsListOptions = (options?: Options<IduLogsListData>) =>
  queryOptions<
    IduLogsListResponse2,
    IduLogsListError,
    IduLogsListResponse2,
    ReturnType<typeof iduLogsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduLogsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduLogsListQueryKey(options),
  });

export const iduLogsListInfiniteQueryKey = (
  options?: Options<IduLogsListData>,
): QueryKey<Options<IduLogsListData>> => createQueryKey('iduLogsList', options, true);

/**
 * List logs
 *
 * List frontend and backend log entries for the admin dashboard.
 */
export const iduLogsListInfiniteOptions = (options?: Options<IduLogsListData>) => {
  const opts = infiniteQueryOptions<
    IduLogsListResponse2,
    IduLogsListError,
    InfiniteData<IduLogsListResponse2>,
    QueryKey<Options<IduLogsListData>>,
    string | Pick<QueryKey<Options<IduLogsListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduLogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduLogsList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduLogsListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduVenueListQueryKey = (options?: Options<IduVenueListData>) =>
  createQueryKey('iduVenueList', options);

/**
 * List venues
 *
 * List all venues (admin dashboard only)
 */
export const iduVenueListOptions = (options?: Options<IduVenueListData>) =>
  queryOptions<
    IduVenueListResponse,
    IduVenueListError,
    IduVenueListResponse,
    ReturnType<typeof iduVenueListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueListQueryKey(options),
  });

export const iduVenueListInfiniteQueryKey = (
  options?: Options<IduVenueListData>,
): QueryKey<Options<IduVenueListData>> => createQueryKey('iduVenueList', options, true);

/**
 * List venues
 *
 * List all venues (admin dashboard only)
 */
export const iduVenueListInfiniteOptions = (options?: Options<IduVenueListData>) => {
  const opts = infiniteQueryOptions<
    IduVenueListResponse,
    IduVenueListError,
    InfiniteData<IduVenueListResponse>,
    QueryKey<Options<IduVenueListData>>,
    string | Pick<QueryKey<Options<IduVenueListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduVenueListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduVenueList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduVenueListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create a venue
 *
 * Create a new venue (admin dashboard only)
 */
export const iduVenueCreateMutation = (
  options?: Partial<Options<IduVenueCreateData>>,
): UseMutationOptions<IduVenueCreateResponse, IduVenueCreateError, Options<IduVenueCreateData>> => {
  const mutationOptions: UseMutationOptions<
    IduVenueCreateResponse,
    IduVenueCreateError,
    Options<IduVenueCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduVenueCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduVenueGetQueryKey = (options: Options<IduVenueGetData>) =>
  createQueryKey('iduVenueGet', options);

/**
 * Get venue details
 *
 * Get a single venue (admin dashboard only)
 */
export const iduVenueGetOptions = (options: Options<IduVenueGetData>) =>
  queryOptions<
    IduVenueGetResponse,
    IduVenueGetError,
    IduVenueGetResponse,
    ReturnType<typeof iduVenueGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueGetQueryKey(options),
  });

/**
 * Update venue
 *
 * Update venue details (admin dashboard only)
 */
export const iduVenueUpdateMutation = (
  options?: Partial<Options<IduVenueUpdateData>>,
): UseMutationOptions<IduVenueUpdateResponse, IduVenueUpdateError, Options<IduVenueUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    IduVenueUpdateResponse,
    IduVenueUpdateError,
    Options<IduVenueUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduVenueUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduAuditListQueryKey = (options?: Options<IduAuditListData>) =>
  createQueryKey('iduAuditList', options);

/**
 * Query CS admin audit trail
 *
 * Query the CS admin audit trail (projected from the immutable GCP audit sink) by actor/entity/venue/action/date-range.
 */
export const iduAuditListOptions = (options?: Options<IduAuditListData>) =>
  queryOptions<
    IduAuditListResponse,
    IduAuditListError,
    IduAuditListResponse,
    ReturnType<typeof iduAuditListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduAuditList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduAuditListQueryKey(options),
  });

export const iduAuditListInfiniteQueryKey = (
  options?: Options<IduAuditListData>,
): QueryKey<Options<IduAuditListData>> => createQueryKey('iduAuditList', options, true);

/**
 * Query CS admin audit trail
 *
 * Query the CS admin audit trail (projected from the immutable GCP audit sink) by actor/entity/venue/action/date-range.
 */
export const iduAuditListInfiniteOptions = (options?: Options<IduAuditListData>) => {
  const opts = infiniteQueryOptions<
    IduAuditListResponse,
    IduAuditListError,
    InfiniteData<IduAuditListResponse>,
    QueryKey<Options<IduAuditListData>>,
    string | Pick<QueryKey<Options<IduAuditListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduAuditListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduAuditList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduAuditListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduVenueUsersListQueryKey = (options: Options<IduVenueUsersListData>) =>
  createQueryKey('iduVenueUsersList', options);

/**
 * List users for a venue
 *
 * List users for a given venue + application (admin dashboard only)
 */
export const iduVenueUsersListOptions = (options: Options<IduVenueUsersListData>) =>
  queryOptions<
    IduVenueUsersListResponse,
    IduVenueUsersListError,
    IduVenueUsersListResponse,
    ReturnType<typeof iduVenueUsersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueUsersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueUsersListQueryKey(options),
  });

export const iduVenueUsersListInfiniteQueryKey = (
  options: Options<IduVenueUsersListData>,
): QueryKey<Options<IduVenueUsersListData>> => createQueryKey('iduVenueUsersList', options, true);

/**
 * List users for a venue
 *
 * List users for a given venue + application (admin dashboard only)
 */
export const iduVenueUsersListInfiniteOptions = (options: Options<IduVenueUsersListData>) => {
  const opts = infiniteQueryOptions<
    IduVenueUsersListResponse,
    IduVenueUsersListError,
    InfiniteData<IduVenueUsersListResponse>,
    QueryKey<Options<IduVenueUsersListData>>,
    | string
    | Pick<QueryKey<Options<IduVenueUsersListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduVenueUsersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduVenueUsersList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduVenueUsersListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduVenueRolesListQueryKey = (options: Options<IduVenueRolesListData>) =>
  createQueryKey('iduVenueRolesList', options);

/**
 * List a venue-application's roles
 *
 * The target venue-application's roles with help text (admin dashboard only)
 */
export const iduVenueRolesListOptions = (options: Options<IduVenueRolesListData>) =>
  queryOptions<
    IduVenueRolesListResponse,
    IduVenueRolesListError,
    IduVenueRolesListResponse,
    ReturnType<typeof iduVenueRolesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueRolesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueRolesListQueryKey(options),
  });

export const iduCheckdVenueSettingGetQueryKey = (options: Options<IduCheckdVenueSettingGetData>) =>
  createQueryKey('iduCheckdVenueSettingGet', options);

/**
 * Get Checkd venue settings
 *
 * Get a venue’s Checkd (pokie payout) settings, including internally-managed fields (venue lat/long for the distance risk rule, ConnectID availability) that Checkd itself cannot write (admin dashboard only)
 */
export const iduCheckdVenueSettingGetOptions = (options: Options<IduCheckdVenueSettingGetData>) =>
  queryOptions<
    IduCheckdVenueSettingGetResponse,
    IduCheckdVenueSettingGetError,
    IduCheckdVenueSettingGetResponse,
    ReturnType<typeof iduCheckdVenueSettingGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduCheckdVenueSettingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduCheckdVenueSettingGetQueryKey(options),
  });

/**
 * Update Checkd venue settings
 *
 * Update a venue's Checkd (pokie payout) settings, including internally-managed fields (venue lat/long for the distance risk rule, ConnectID availability) that Checkd itself cannot write (admin dashboard only)
 */
export const iduCheckdVenueSettingUpdateMutation = (
  options?: Partial<Options<IduCheckdVenueSettingUpdateData>>,
): UseMutationOptions<
  IduCheckdVenueSettingUpdateResponse,
  IduCheckdVenueSettingUpdateError,
  Options<IduCheckdVenueSettingUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduCheckdVenueSettingUpdateResponse,
    IduCheckdVenueSettingUpdateError,
    Options<IduCheckdVenueSettingUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduCheckdVenueSettingUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Record a venue's Merchant Warrior payout credentials
 *
 * Writes the three values into this venue’s entry in the shared credential secret, replacing any previous entry (rotation) and carrying every other venue’s entry forward unchanged. The response body carries nothing about what was written — no echo, no masked preview (FR-002) — which is why this is its own endpoint rather than a Checkd venue-settings field.
 */
export const iduVenueMwCredentialsUpdateMutation = (
  options?: Partial<Options<IduVenueMwCredentialsUpdateData>>,
): UseMutationOptions<
  IduVenueMwCredentialsUpdateResponse,
  IduVenueMwCredentialsUpdateError,
  Options<IduVenueMwCredentialsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduVenueMwCredentialsUpdateResponse,
    IduVenueMwCredentialsUpdateError,
    Options<IduVenueMwCredentialsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduVenueMwCredentialsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduVenueMwCredentialsStatusQueryKey = (
  options: Options<IduVenueMwCredentialsStatusData>,
) => createQueryKey('iduVenueMwCredentialsStatus', options);

/**
 * Whether a venue has Merchant Warrior credentials, and when they were last written
 *
 * Existence and last-written only (FR-003) — never any part of a value. The retrieval path also returns the secret version this venue’s entry was read from; that is an internal write-concurrency token and is deliberately not projected here.
 */
export const iduVenueMwCredentialsStatusOptions = (
  options: Options<IduVenueMwCredentialsStatusData>,
) =>
  queryOptions<
    IduVenueMwCredentialsStatusResponse,
    IduVenueMwCredentialsStatusError,
    IduVenueMwCredentialsStatusResponse,
    ReturnType<typeof iduVenueMwCredentialsStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueMwCredentialsStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueMwCredentialsStatusQueryKey(options),
  });

/**
 * Summary
 *
 * Description
 */
export const iduVenueApplicationAssignMutation = (
  options?: Partial<Options<IduVenueApplicationAssignData>>,
): UseMutationOptions<
  IduVenueApplicationAssignResponse2,
  IduVenueApplicationAssignError,
  Options<IduVenueApplicationAssignData>
> => {
  const mutationOptions: UseMutationOptions<
    IduVenueApplicationAssignResponse2,
    IduVenueApplicationAssignError,
    Options<IduVenueApplicationAssignData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduVenueApplicationAssign({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Summary
 *
 * Description
 */
export const iduVenueApplicationRemoveMutation = (
  options?: Partial<Options<IduVenueApplicationRemoveData>>,
): UseMutationOptions<
  IduVenueApplicationRemoveResponse2,
  IduVenueApplicationRemoveError,
  Options<IduVenueApplicationRemoveData>
> => {
  const mutationOptions: UseMutationOptions<
    IduVenueApplicationRemoveResponse2,
    IduVenueApplicationRemoveError,
    Options<IduVenueApplicationRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduVenueApplicationRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduNightlifeVenueListQueryKey = (options: Options<IduNightlifeVenueListData>) =>
  createQueryKey('iduNightlifeVenueList', options);

/**
 * List nightlife venues, a page at a time
 *
 * The application's nightlife venues beside their web-apps links (linked, unlinked, or linked but needing a HubSpot id), 200 at most a page, of one customer status when given. Pass each nextCursor back as cursor until it is null; search what has been read.
 */
export const iduNightlifeVenueListOptions = (options: Options<IduNightlifeVenueListData>) =>
  queryOptions<
    IduNightlifeVenueListResponse,
    IduNightlifeVenueListError,
    IduNightlifeVenueListResponse,
    ReturnType<typeof iduNightlifeVenueListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduNightlifeVenueList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduNightlifeVenueListQueryKey(options),
  });

export const iduNightlifeVenueListInfiniteQueryKey = (
  options: Options<IduNightlifeVenueListData>,
): QueryKey<Options<IduNightlifeVenueListData>> =>
  createQueryKey('iduNightlifeVenueList', options, true);

/**
 * List nightlife venues, a page at a time
 *
 * The application's nightlife venues beside their web-apps links (linked, unlinked, or linked but needing a HubSpot id), 200 at most a page, of one customer status when given. Pass each nextCursor back as cursor until it is null; search what has been read.
 */
export const iduNightlifeVenueListInfiniteOptions = (
  options: Options<IduNightlifeVenueListData>,
) => {
  const opts = infiniteQueryOptions<
    IduNightlifeVenueListResponse,
    IduNightlifeVenueListError,
    InfiniteData<IduNightlifeVenueListResponse>,
    QueryKey<Options<IduNightlifeVenueListData>>,
    | string
    | Pick<QueryKey<Options<IduNightlifeVenueListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduNightlifeVenueListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduNightlifeVenueList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduNightlifeVenueListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create a venue for a nightlife venue
 *
 * Creates a web-apps venue from the nightlife venue and links the two, without matching on HubSpot id (link to an existing venue with link-to). The new venue takes the nightlife venue's HubSpot company id. Enables the application on the venue and writes webappsVenueId to the nightlife document. Repeating it on a linked nightlife venue re-writes the document.
 */
export const iduNightlifeVenueLinkMutation = (
  options?: Partial<Options<IduNightlifeVenueLinkData>>,
): UseMutationOptions<
  IduNightlifeVenueLinkResponse,
  IduNightlifeVenueLinkError,
  Options<IduNightlifeVenueLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    IduNightlifeVenueLinkResponse,
    IduNightlifeVenueLinkError,
    Options<IduNightlifeVenueLinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduNightlifeVenueLink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Link a nightlife venue to a chosen venue
 *
 * Links an unlinked nightlife venue to the web-apps venue staff chose, e.g. after an ambiguous HubSpot match. 409 when either side is already linked in the application.
 */
export const iduNightlifeVenueLinkToMutation = (
  options?: Partial<Options<IduNightlifeVenueLinkToData>>,
): UseMutationOptions<
  IduNightlifeVenueLinkToResponse,
  IduNightlifeVenueLinkToError,
  Options<IduNightlifeVenueLinkToData>
> => {
  const mutationOptions: UseMutationOptions<
    IduNightlifeVenueLinkToResponse,
    IduNightlifeVenueLinkToError,
    Options<IduNightlifeVenueLinkToData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduNightlifeVenueLinkTo({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Relink a nightlife venue
 *
 * Moves a nightlife venue's link to another web-apps venue, with the previous venue's grants and pending invites for the application. Nightlife access does not change. The previous venue's application is turned off.
 */
export const iduNightlifeVenueRelinkMutation = (
  options?: Partial<Options<IduNightlifeVenueRelinkData>>,
): UseMutationOptions<
  IduNightlifeVenueRelinkResponse,
  IduNightlifeVenueRelinkError,
  Options<IduNightlifeVenueRelinkData>
> => {
  const mutationOptions: UseMutationOptions<
    IduNightlifeVenueRelinkResponse,
    IduNightlifeVenueRelinkError,
    Options<IduNightlifeVenueRelinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduNightlifeVenueRelink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduVenueNightlifeLinksQueryKey = (options: Options<IduVenueNightlifeLinksData>) =>
  createQueryKey('iduVenueNightlifeLinks', options);

/**
 * A venue's nightlife links
 *
 * For each nightlife application: whether this environment reaches its nightlife API, and the nightlife venue the web-apps venue is linked to, if any.
 */
export const iduVenueNightlifeLinksOptions = (options: Options<IduVenueNightlifeLinksData>) =>
  queryOptions<
    IduVenueNightlifeLinksResponse,
    IduVenueNightlifeLinksError,
    IduVenueNightlifeLinksResponse,
    ReturnType<typeof iduVenueNightlifeLinksQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueNightlifeLinks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueNightlifeLinksQueryKey(options),
  });

/**
 * Create a nightlife venue for a venue
 *
 * Creates the nightlife venue document for this web-apps venue (its name, status and HubSpot id come from the venue), links it and enables the application. 409 when the venue is already linked, or SITE_NUMBER_TAKEN / SITE_NUMBER_SHARED from nightlife. The venue's address is rewritten from the structured address.
 */
export const iduVenueNightlifeCreateMutation = (
  options?: Partial<Options<IduVenueNightlifeCreateData>>,
): UseMutationOptions<
  IduVenueNightlifeCreateResponse,
  IduVenueNightlifeCreateError,
  Options<IduVenueNightlifeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduVenueNightlifeCreateResponse,
    IduVenueNightlifeCreateError,
    Options<IduVenueNightlifeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduVenueNightlifeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduVenueNightlifeSettingsGetQueryKey = (
  options: Options<IduVenueNightlifeSettingsGetData>,
) => createQueryKey('iduVenueNightlifeSettingsGet', options);

/**
 * A venue's nightlife settings
 *
 * The linked nightlife venue document, read through the internal nightlife API.
 */
export const iduVenueNightlifeSettingsGetOptions = (
  options: Options<IduVenueNightlifeSettingsGetData>,
) =>
  queryOptions<
    IduVenueNightlifeSettingsGetResponse,
    IduVenueNightlifeSettingsGetError,
    IduVenueNightlifeSettingsGetResponse,
    ReturnType<typeof iduVenueNightlifeSettingsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueNightlifeSettingsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueNightlifeSettingsGetQueryKey(options),
  });

/**
 * Update a venue's nightlife settings
 *
 * Writes the given nightlife-only fields to the linked nightlife venue; `settings` sections merge into the stored ones. Name, status and HubSpot id are the web-apps venue's and are not accepted here. Changing the structured address also rewrites the venue's address.
 */
export const iduVenueNightlifeSettingsUpdateMutation = (
  options?: Partial<Options<IduVenueNightlifeSettingsUpdateData>>,
): UseMutationOptions<
  IduVenueNightlifeSettingsUpdateResponse,
  IduVenueNightlifeSettingsUpdateError,
  Options<IduVenueNightlifeSettingsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduVenueNightlifeSettingsUpdateResponse,
    IduVenueNightlifeSettingsUpdateError,
    Options<IduVenueNightlifeSettingsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduVenueNightlifeSettingsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduVenueNightlifeLegacyManagersQueryKey = (
  options: Options<IduVenueNightlifeLegacyManagersData>,
) => createQueryKey('iduVenueNightlifeLegacyManagers', options);

/**
 * A venue's unmoved nightlife managers
 *
 * Managers at the linked nightlife venue still on an old iDU login that has not moved to its own account.
 */
export const iduVenueNightlifeLegacyManagersOptions = (
  options: Options<IduVenueNightlifeLegacyManagersData>,
) =>
  queryOptions<
    IduVenueNightlifeLegacyManagersResponse,
    IduVenueNightlifeLegacyManagersError,
    IduVenueNightlifeLegacyManagersResponse,
    ReturnType<typeof iduVenueNightlifeLegacyManagersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduVenueNightlifeLegacyManagers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduVenueNightlifeLegacyManagersQueryKey(options),
  });

export const iduKycDashboardQueryKey = (options?: Options<IduKycDashboardData>) =>
  createQueryKey('iduKycDashboard', options);

/**
 * KYC Dashboard
 *
 * Get metrics for KYC (admin dashboard only)
 */
export const iduKycDashboardOptions = (options?: Options<IduKycDashboardData>) =>
  queryOptions<
    IduKycDashboardResponse,
    IduKycDashboardError,
    IduKycDashboardResponse,
    ReturnType<typeof iduKycDashboardQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduKycDashboard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduKycDashboardQueryKey(options),
  });

export const iduPepCheckActivityListQueryKey = (options?: Options<IduPepCheckActivityListData>) =>
  createQueryKey('iduPepCheckActivityList', options);

/**
 * List PEP check activity
 *
 * Paginated list of PEP (BNDRY) checks with venue, payout, trigger reason, reuse and outcome, for admin traceability/investigation (admin dashboard only)
 */
export const iduPepCheckActivityListOptions = (options?: Options<IduPepCheckActivityListData>) =>
  queryOptions<
    IduPepCheckActivityListResponse,
    IduPepCheckActivityListError,
    IduPepCheckActivityListResponse,
    ReturnType<typeof iduPepCheckActivityListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduPepCheckActivityList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduPepCheckActivityListQueryKey(options),
  });

export const iduPepCheckActivityListInfiniteQueryKey = (
  options?: Options<IduPepCheckActivityListData>,
): QueryKey<Options<IduPepCheckActivityListData>> =>
  createQueryKey('iduPepCheckActivityList', options, true);

/**
 * List PEP check activity
 *
 * Paginated list of PEP (BNDRY) checks with venue, payout, trigger reason, reuse and outcome, for admin traceability/investigation (admin dashboard only)
 */
export const iduPepCheckActivityListInfiniteOptions = (
  options?: Options<IduPepCheckActivityListData>,
) => {
  const opts = infiniteQueryOptions<
    IduPepCheckActivityListResponse,
    IduPepCheckActivityListError,
    InfiniteData<IduPepCheckActivityListResponse>,
    QueryKey<Options<IduPepCheckActivityListData>>,
    | number
    | Pick<QueryKey<Options<IduPepCheckActivityListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduPepCheckActivityListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduPepCheckActivityList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduPepCheckActivityListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduPepCheckRunStatsQueryKey = (options?: Options<IduPepCheckRunStatsData>) =>
  createQueryKey('iduPepCheckRunStats', options);

/**
 * PEP check run stats
 *
 * Fresh vs. reused BNDRY PEP check counts for a period, to spot wasted re-checks / BNDRY spend (admin dashboard only)
 */
export const iduPepCheckRunStatsOptions = (options?: Options<IduPepCheckRunStatsData>) =>
  queryOptions<
    IduPepCheckRunStatsResponse,
    IduPepCheckRunStatsError,
    IduPepCheckRunStatsResponse,
    ReturnType<typeof iduPepCheckRunStatsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduPepCheckRunStats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduPepCheckRunStatsQueryKey(options),
  });

export const iduBndryAlertHistoryQueryKey = (options?: Options<IduBndryAlertHistoryData>) =>
  createQueryKey('iduBndryAlertHistory', options);

/**
 * BNDRY threshold alert history
 *
 * History of BNDRY daily-threshold emails actually sent, including the window, count, threshold and environment for each (admin dashboard only)
 */
export const iduBndryAlertHistoryOptions = (options?: Options<IduBndryAlertHistoryData>) =>
  queryOptions<
    IduBndryAlertHistoryResponse,
    IduBndryAlertHistoryError,
    IduBndryAlertHistoryResponse,
    ReturnType<typeof iduBndryAlertHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduBndryAlertHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduBndryAlertHistoryQueryKey(options),
  });

export const iduSettingsGetQueryKey = (options?: Options<IduSettingsGetData>) =>
  createQueryKey('iduSettingsGet', options);

/**
 * Get IDU Settings
 *
 * Get IDU settings (admin dashboard only)
 */
export const iduSettingsGetOptions = (options?: Options<IduSettingsGetData>) =>
  queryOptions<
    IduSettingsGetResponse,
    IduSettingsGetError,
    IduSettingsGetResponse,
    ReturnType<typeof iduSettingsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduSettingsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduSettingsGetQueryKey(options),
  });

/**
 * Update IDU Settings
 *
 * Update IDU settings (admin dashboard only)
 */
export const iduSettingsUpdateMutation = (
  options?: Partial<Options<IduSettingsUpdateData>>,
): UseMutationOptions<
  IduSettingsUpdateResponse,
  IduSettingsUpdateError,
  Options<IduSettingsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduSettingsUpdateResponse,
    IduSettingsUpdateError,
    Options<IduSettingsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduSettingsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduUserListQueryKey = (options?: Options<IduUserListData>) =>
  createQueryKey('iduUserList', options);

/**
 * List users
 *
 * List all users (admin dashboard only)
 */
export const iduUserListOptions = (options?: Options<IduUserListData>) =>
  queryOptions<
    IduUserListResponse,
    IduUserListError,
    IduUserListResponse,
    ReturnType<typeof iduUserListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduUserList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduUserListQueryKey(options),
  });

export const iduUserListInfiniteQueryKey = (
  options?: Options<IduUserListData>,
): QueryKey<Options<IduUserListData>> => createQueryKey('iduUserList', options, true);

/**
 * List users
 *
 * List all users (admin dashboard only)
 */
export const iduUserListInfiniteOptions = (options?: Options<IduUserListData>) => {
  const opts = infiniteQueryOptions<
    IduUserListResponse,
    IduUserListError,
    InfiniteData<IduUserListResponse>,
    QueryKey<Options<IduUserListData>>,
    string | Pick<QueryKey<Options<IduUserListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduUserListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduUserList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduUserListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create user
 *
 * Create a new user and optionally associate them to venues
 */
export const iduUserCreateMutation = (
  options?: Partial<Options<IduUserCreateData>>,
): UseMutationOptions<IduUserCreateResponse2, IduUserCreateError, Options<IduUserCreateData>> => {
  const mutationOptions: UseMutationOptions<
    IduUserCreateResponse2,
    IduUserCreateError,
    Options<IduUserCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduUserEmailSearchQueryKey = (options: Options<IduUserEmailSearchData>) =>
  createQueryKey('iduUserEmailSearch', options);

/**
 * Search user by email
 *
 * Get a single user by querying with their email
 */
export const iduUserEmailSearchOptions = (options: Options<IduUserEmailSearchData>) =>
  queryOptions<
    IduUserEmailSearchResponse,
    IduUserEmailSearchError,
    IduUserEmailSearchResponse,
    ReturnType<typeof iduUserEmailSearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduUserEmailSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduUserEmailSearchQueryKey(options),
  });

export const iduUserSearchQueryKey = (options?: Options<IduUserSearchData>) =>
  createQueryKey('iduUserSearch', options);

/**
 * Unrestricted user search
 *
 * Search for users without needing a venue. This returns users across the whole iDU database.
 */
export const iduUserSearchOptions = (options?: Options<IduUserSearchData>) =>
  queryOptions<
    IduUserSearchResponse2,
    IduUserSearchError,
    IduUserSearchResponse2,
    ReturnType<typeof iduUserSearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduUserSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduUserSearchQueryKey(options),
  });

export const iduUserSearchInfiniteQueryKey = (
  options?: Options<IduUserSearchData>,
): QueryKey<Options<IduUserSearchData>> => createQueryKey('iduUserSearch', options, true);

/**
 * Unrestricted user search
 *
 * Search for users without needing a venue. This returns users across the whole iDU database.
 */
export const iduUserSearchInfiniteOptions = (options?: Options<IduUserSearchData>) => {
  const opts = infiniteQueryOptions<
    IduUserSearchResponse2,
    IduUserSearchError,
    InfiniteData<IduUserSearchResponse2>,
    QueryKey<Options<IduUserSearchData>>,
    string | Pick<QueryKey<Options<IduUserSearchData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduUserSearchData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduUserSearch({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduUserSearchInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduUserGetQueryKey = (options: Options<IduUserGetData>) =>
  createQueryKey('iduUserGet', options);

/**
 * Get user details
 *
 * Get a single user and their venue/application assignments (admin dashboard only)
 */
export const iduUserGetOptions = (options: Options<IduUserGetData>) =>
  queryOptions<
    IduUserGetResponse,
    IduUserGetError,
    IduUserGetResponse,
    ReturnType<typeof iduUserGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduUserGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduUserGetQueryKey(options),
  });

/**
 * Update user
 *
 * Update user profile fields (admin dashboard only)
 */
export const iduUserUpdateMutation = (
  options?: Partial<Options<IduUserUpdateData>>,
): UseMutationOptions<IduUserUpdateResponse, IduUserUpdateError, Options<IduUserUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    IduUserUpdateResponse,
    IduUserUpdateError,
    Options<IduUserUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a user from a venue
 *
 * Disassociate an existing user from an existing venue (admin dashboard only)
 */
export const iduUserRemoveFromVenueMutation = (
  options?: Partial<Options<IduUserRemoveFromVenueData>>,
): UseMutationOptions<
  IduUserRemoveFromVenueResponse,
  IduUserRemoveFromVenueError,
  Options<IduUserRemoveFromVenueData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserRemoveFromVenueResponse,
    IduUserRemoveFromVenueError,
    Options<IduUserRemoveFromVenueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserRemoveFromVenue({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Associate a user to a venue
 *
 * Associate an existing user with an existing venue (admin dashboard only)
 */
export const iduUserAssignToVenueMutation = (
  options?: Partial<Options<IduUserAssignToVenueData>>,
): UseMutationOptions<
  IduUserAssignToVenueResponse,
  IduUserAssignToVenueError,
  Options<IduUserAssignToVenueData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserAssignToVenueResponse,
    IduUserAssignToVenueError,
    Options<IduUserAssignToVenueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserAssignToVenue({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reset or override a user password
 *
 * Override a password or trigger a password reset email (admin dashboard only)
 */
export const iduUserPasswordChangeMutation = (
  options?: Partial<Options<IduUserPasswordChangeData>>,
): UseMutationOptions<
  IduUserPasswordChangeResponse,
  IduUserPasswordChangeError,
  Options<IduUserPasswordChangeData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserPasswordChangeResponse,
    IduUserPasswordChangeError,
    Options<IduUserPasswordChangeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserPasswordChange({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reset or override a user password
 *
 * Override a password or trigger a password reset email (admin dashboard only)
 */
export const iduUserResetPasswordMutation = (
  options?: Partial<Options<IduUserResetPasswordData>>,
): UseMutationOptions<
  IduUserResetPasswordResponse,
  IduUserResetPasswordError,
  Options<IduUserResetPasswordData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserResetPasswordResponse,
    IduUserResetPasswordError,
    Options<IduUserResetPasswordData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserResetPassword({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduUserTwoStepQueryKey = (options: Options<IduUserTwoStepData>) =>
  createQueryKey('iduUserTwoStep', options);

/**
 * Get a user's two-step sign-in
 *
 * Whether two-step sign-in is on and which kinds of method are set up; never a secret
 */
export const iduUserTwoStepOptions = (options: Options<IduUserTwoStepData>) =>
  queryOptions<
    IduUserTwoStepResponse,
    IduUserTwoStepError,
    IduUserTwoStepResponse,
    ReturnType<typeof iduUserTwoStepQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduUserTwoStep({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduUserTwoStepQueryKey(options),
  });

/**
 * Turn a user's two-step sign-in on or off
 *
 * Refused with 409 while the account's access requires it. Turning it off needs a reason. Audited.
 */
export const iduUserTwoStepUpdateMutation = (
  options?: Partial<Options<IduUserTwoStepUpdateData>>,
): UseMutationOptions<
  IduUserTwoStepUpdateResponse,
  IduUserTwoStepUpdateError,
  Options<IduUserTwoStepUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserTwoStepUpdateResponse,
    IduUserTwoStepUpdateError,
    Options<IduUserTwoStepUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserTwoStepUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reset a user's two-step sign-in
 *
 * Removes their methods, remembered devices, sent codes and lockout, so they set up a new method at their next sign-in. Audited with the reason, and the person is emailed.
 */
export const iduUserTwoStepResetMutation = (
  options?: Partial<Options<IduUserTwoStepResetData>>,
): UseMutationOptions<
  IduUserTwoStepResetResponse,
  IduUserTwoStepResetError,
  Options<IduUserTwoStepResetData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserTwoStepResetResponse,
    IduUserTwoStepResetError,
    Options<IduUserTwoStepResetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserTwoStepReset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Give a user a one-time sign-in code
 *
 * Passes one sign-in's second step within 15 minutes, replacing any earlier code, and clears a lockout. Their methods and devices are unchanged, and a pass from it can't change them. Never for the admin's own account. Audited with the reason, and the person is emailed.
 */
export const iduUserTwoStepCodeMutation = (
  options?: Partial<Options<IduUserTwoStepCodeData>>,
): UseMutationOptions<
  IduUserTwoStepCodeResponse,
  IduUserTwoStepCodeError,
  Options<IduUserTwoStepCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserTwoStepCodeResponse,
    IduUserTwoStepCodeError,
    Options<IduUserTwoStepCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserTwoStepCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Summary
 *
 * Description
 */
export const iduUserInviteCreateMutation = (
  options?: Partial<Options<IduUserInviteCreateData>>,
): UseMutationOptions<
  IduUserInviteCreateResponse,
  IduUserInviteCreateError,
  Options<IduUserInviteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduUserInviteCreateResponse,
    IduUserInviteCreateError,
    Options<IduUserInviteCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduUserInviteCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Manually accept a pending invitation (override)
 *
 * iDU-admin-only. Activates the association without the recipient following the link. Bypasses proof of address, so the account still requires email verification before use.
 */
export const iduInviteManualAcceptMutation = (
  options?: Partial<Options<IduInviteManualAcceptData>>,
): UseMutationOptions<
  IduInviteManualAcceptResponse,
  IduInviteManualAcceptError,
  Options<IduInviteManualAcceptData>
> => {
  const mutationOptions: UseMutationOptions<
    IduInviteManualAcceptResponse,
    IduInviteManualAcceptError,
    Options<IduInviteManualAcceptData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduInviteManualAccept({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add a user directly, skipping the invite process
 *
 * iDU-admin-only. Creates the user (if needed) and an active association with no invite. The resulting account still requires email verification before use (Q-A) — skipping the invite never exempts anyone from FR-001.
 */
export const iduInviteSkipAndAddMutation = (
  options?: Partial<Options<IduInviteSkipAndAddData>>,
): UseMutationOptions<
  IduInviteSkipAndAddResponse,
  IduInviteSkipAndAddError,
  Options<IduInviteSkipAndAddData>
> => {
  const mutationOptions: UseMutationOptions<
    IduInviteSkipAndAddResponse,
    IduInviteSkipAndAddError,
    Options<IduInviteSkipAndAddData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduInviteSkipAndAdd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Re-send a venue invitation
 *
 * iDU-admin-only. Issues a fresh link and expiry for an existing pending invitation and sends a new email. The window comes from idu_settings, so a re-send picks up the currently configured expiry rather than the one the original invite was issued under.
 */
export const iduInviteResendMutation = (
  options?: Partial<Options<IduInviteResendData>>,
): UseMutationOptions<
  IduInviteResendResponse,
  IduInviteResendError,
  Options<IduInviteResendData>
> => {
  const mutationOptions: UseMutationOptions<
    IduInviteResendResponse,
    IduInviteResendError,
    Options<IduInviteResendData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduInviteResend({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke a venue invitation
 *
 * iDU-admin-only. Removes a never-accepted invitation entirely, and with it the placeholder user record where that person has no authentication identity, no grant anywhere and no other pending invite (FR-008/Q-L). An accepted invitation is never reachable by this path.
 */
export const iduInviteRevokeMutation = (
  options?: Partial<Options<IduInviteRevokeData>>,
): UseMutationOptions<
  IduInviteRevokeResponse,
  IduInviteRevokeError,
  Options<IduInviteRevokeData>
> => {
  const mutationOptions: UseMutationOptions<
    IduInviteRevokeResponse,
    IduInviteRevokeError,
    Options<IduInviteRevokeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduInviteRevoke({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduInviteListQueryKey = (options?: Options<IduInviteListData>) =>
  createQueryKey('iduInviteList', options);

/**
 * List invitations
 *
 * iDU-admin-only. Lists invitations across all venues and applications, with the venue, role and application each one grants and the server-authoritative expiry. Defaults to pending invitations.
 */
export const iduInviteListOptions = (options?: Options<IduInviteListData>) =>
  queryOptions<
    IduInviteListResponse,
    IduInviteListError,
    IduInviteListResponse,
    ReturnType<typeof iduInviteListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduInviteList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduInviteListQueryKey(options),
  });

export const iduInviteListInfiniteQueryKey = (
  options?: Options<IduInviteListData>,
): QueryKey<Options<IduInviteListData>> => createQueryKey('iduInviteList', options, true);

/**
 * List invitations
 *
 * iDU-admin-only. Lists invitations across all venues and applications, with the venue, role and application each one grants and the server-authoritative expiry. Defaults to pending invitations.
 */
export const iduInviteListInfiniteOptions = (options?: Options<IduInviteListData>) => {
  const opts = infiniteQueryOptions<
    IduInviteListResponse,
    IduInviteListError,
    InfiniteData<IduInviteListResponse>,
    QueryKey<Options<IduInviteListData>>,
    string | Pick<QueryKey<Options<IduInviteListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduInviteListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduInviteList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduInviteListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

export const iduInviteAvailabilityQueryKey = (options?: Options<IduInviteAvailabilityData>) =>
  createQueryKey('iduInviteAvailability', options);

/**
 * Invite delivery availability
 *
 * iDU-admin-only. For every application, whether an invite can be issued as a link and sent as an email in this environment, with the refusal code when it cannot. The same rules the invite and resend endpoints refuse with.
 */
export const iduInviteAvailabilityOptions = (options?: Options<IduInviteAvailabilityData>) =>
  queryOptions<
    IduInviteAvailabilityResponse,
    IduInviteAvailabilityError,
    IduInviteAvailabilityResponse,
    ReturnType<typeof iduInviteAvailabilityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduInviteAvailability({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduInviteAvailabilityQueryKey(options),
  });

export const iduDashboardUsersListQueryKey = (options?: Options<IduDashboardUsersListData>) =>
  createQueryKey('iduDashboardUsersList', options);

/**
 * List dashboard users
 *
 * iDU-admin-only. Lists everyone holding a grant on the iDU dashboard venue, with the role each one holds, so admin and non-admin access are distinguishable.
 */
export const iduDashboardUsersListOptions = (options?: Options<IduDashboardUsersListData>) =>
  queryOptions<
    IduDashboardUsersListResponse,
    IduDashboardUsersListError,
    IduDashboardUsersListResponse,
    ReturnType<typeof iduDashboardUsersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduDashboardUsersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduDashboardUsersListQueryKey(options),
  });

export const iduDashboardUsersListInfiniteQueryKey = (
  options?: Options<IduDashboardUsersListData>,
): QueryKey<Options<IduDashboardUsersListData>> =>
  createQueryKey('iduDashboardUsersList', options, true);

/**
 * List dashboard users
 *
 * iDU-admin-only. Lists everyone holding a grant on the iDU dashboard venue, with the role each one holds, so admin and non-admin access are distinguishable.
 */
export const iduDashboardUsersListInfiniteOptions = (
  options?: Options<IduDashboardUsersListData>,
) => {
  const opts = infiniteQueryOptions<
    IduDashboardUsersListResponse,
    IduDashboardUsersListError,
    InfiniteData<IduDashboardUsersListResponse>,
    QueryKey<Options<IduDashboardUsersListData>>,
    | string
    | Pick<QueryKey<Options<IduDashboardUsersListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduDashboardUsersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduDashboardUsersList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduDashboardUsersListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Grant dashboard access
 *
 * iDU-admin-only. Grants admin access to the iDU dashboard, creating the user if they do not exist. The venue is resolved server-side from the dashboard venue, never supplied by the caller — the dashboard UI runs under whichever venue the operator’s own grant sits on, which is not necessarily the dashboard venue.
 */
export const iduDashboardUserAddMutation = (
  options?: Partial<Options<IduDashboardUserAddData>>,
): UseMutationOptions<
  IduDashboardUserAddResponse,
  IduDashboardUserAddError,
  Options<IduDashboardUserAddData>
> => {
  const mutationOptions: UseMutationOptions<
    IduDashboardUserAddResponse,
    IduDashboardUserAddError,
    Options<IduDashboardUserAddData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduDashboardUserAdd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduInAppMessageListQueryKey = (options?: Options<IduInAppMessageListData>) =>
  createQueryKey('iduInAppMessageList', options);

/**
 * List in-app messages
 *
 * List all in-app messages (admin dashboard only)
 */
export const iduInAppMessageListOptions = (options?: Options<IduInAppMessageListData>) =>
  queryOptions<
    IduInAppMessageListResponse,
    IduInAppMessageListError,
    IduInAppMessageListResponse,
    ReturnType<typeof iduInAppMessageListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduInAppMessageList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduInAppMessageListQueryKey(options),
  });

export const iduInAppMessageListInfiniteQueryKey = (
  options?: Options<IduInAppMessageListData>,
): QueryKey<Options<IduInAppMessageListData>> =>
  createQueryKey('iduInAppMessageList', options, true);

/**
 * List in-app messages
 *
 * List all in-app messages (admin dashboard only)
 */
export const iduInAppMessageListInfiniteOptions = (options?: Options<IduInAppMessageListData>) => {
  const opts = infiniteQueryOptions<
    IduInAppMessageListResponse,
    IduInAppMessageListError,
    InfiniteData<IduInAppMessageListResponse>,
    QueryKey<Options<IduInAppMessageListData>>,
    | string
    | Pick<QueryKey<Options<IduInAppMessageListData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IduInAppMessageListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await iduInAppMessageList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: iduInAppMessageListInfiniteQueryKey(options),
    },
  );
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create in-app message
 */
export const iduInAppMessageCreateMutation = (
  options?: Partial<Options<IduInAppMessageCreateData>>,
): UseMutationOptions<
  IduInAppMessageCreateResponse,
  IduInAppMessageCreateError,
  Options<IduInAppMessageCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduInAppMessageCreateResponse,
    IduInAppMessageCreateError,
    Options<IduInAppMessageCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduInAppMessageCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete in-app message
 */
export const iduInAppMessageDeleteMutation = (
  options?: Partial<Options<IduInAppMessageDeleteData>>,
): UseMutationOptions<
  IduInAppMessageDeleteResponse,
  IduInAppMessageDeleteError,
  Options<IduInAppMessageDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    IduInAppMessageDeleteResponse,
    IduInAppMessageDeleteError,
    Options<IduInAppMessageDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduInAppMessageDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const iduInAppMessageGetQueryKey = (options: Options<IduInAppMessageGetData>) =>
  createQueryKey('iduInAppMessageGet', options);

/**
 * Get in-app message
 */
export const iduInAppMessageGetOptions = (options: Options<IduInAppMessageGetData>) =>
  queryOptions<
    IduInAppMessageGetResponse,
    IduInAppMessageGetError,
    IduInAppMessageGetResponse,
    ReturnType<typeof iduInAppMessageGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await iduInAppMessageGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: iduInAppMessageGetQueryKey(options),
  });

/**
 * Update in-app message
 */
export const iduInAppMessageUpdateMutation = (
  options?: Partial<Options<IduInAppMessageUpdateData>>,
): UseMutationOptions<
  IduInAppMessageUpdateResponse,
  IduInAppMessageUpdateError,
  Options<IduInAppMessageUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IduInAppMessageUpdateResponse,
    IduInAppMessageUpdateError,
    Options<IduInAppMessageUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await iduInAppMessageUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const nightlifeManagerListQueryKey = (options: Options<NightlifeManagerListData>) =>
  createQueryKey('nightlifeManagerList', options);

/**
 * List the venue managers and pending invites
 *
 * The nightlife managers and pending manager invites at the venue, for the application the x-idu-application header names.
 */
export const nightlifeManagerListOptions = (options: Options<NightlifeManagerListData>) =>
  queryOptions<
    NightlifeManagerListResponse,
    NightlifeManagerListError,
    NightlifeManagerListResponse,
    ReturnType<typeof nightlifeManagerListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await nightlifeManagerList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: nightlifeManagerListQueryKey(options),
  });

/**
 * Invite a venue manager
 *
 * Emails a Manager invitation to the venue for the application the x-idu-application header names.
 */
export const nightlifeManagerInviteMutation = (
  options?: Partial<Options<NightlifeManagerInviteData>>,
): UseMutationOptions<
  NightlifeManagerInviteResponse,
  NightlifeManagerInviteError,
  Options<NightlifeManagerInviteData>
> => {
  const mutationOptions: UseMutationOptions<
    NightlifeManagerInviteResponse,
    NightlifeManagerInviteError,
    Options<NightlifeManagerInviteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await nightlifeManagerInvite({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Resend a venue manager invite
 *
 * Re-issues and emails a pending Manager invitation at the venue.
 */
export const nightlifeManagerInviteResendMutation = (
  options?: Partial<Options<NightlifeManagerInviteResendData>>,
): UseMutationOptions<
  NightlifeManagerInviteResendResponse,
  NightlifeManagerInviteResendError,
  Options<NightlifeManagerInviteResendData>
> => {
  const mutationOptions: UseMutationOptions<
    NightlifeManagerInviteResendResponse,
    NightlifeManagerInviteResendError,
    Options<NightlifeManagerInviteResendData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await nightlifeManagerInviteResend({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke a venue manager invite
 *
 * Cancels a pending Manager invitation at the venue.
 */
export const nightlifeManagerInviteRevokeMutation = (
  options?: Partial<Options<NightlifeManagerInviteRevokeData>>,
): UseMutationOptions<
  NightlifeManagerInviteRevokeResponse,
  NightlifeManagerInviteRevokeError,
  Options<NightlifeManagerInviteRevokeData>
> => {
  const mutationOptions: UseMutationOptions<
    NightlifeManagerInviteRevokeResponse,
    NightlifeManagerInviteRevokeError,
    Options<NightlifeManagerInviteRevokeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await nightlifeManagerInviteRevoke({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a venue manager
 *
 * Ends an active manager's access to the venue; nightlife ends their sessions there. The record is kept.
 */
export const nightlifeManagerRemoveMutation = (
  options?: Partial<Options<NightlifeManagerRemoveData>>,
): UseMutationOptions<
  NightlifeManagerRemoveResponse,
  NightlifeManagerRemoveError,
  Options<NightlifeManagerRemoveData>
> => {
  const mutationOptions: UseMutationOptions<
    NightlifeManagerRemoveResponse,
    NightlifeManagerRemoveError,
    Options<NightlifeManagerRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await nightlifeManagerRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Grant a moved nightlife login
 *
 * Called by the nightlife API when an old iDU login moves to its own account: creates or reactivates an active Manager grant at the web-apps venue linked to the nightlife venue. 403 when the caller is another nightlife project's service account. 404 VENUE_NOT_LINKED or USER_NOT_FOUND.
 */
export const internalNightlifeGrantCreateMutation = (
  options?: Partial<Options<InternalNightlifeGrantCreateData>>,
): UseMutationOptions<
  InternalNightlifeGrantCreateResponse2,
  InternalNightlifeGrantCreateError,
  Options<InternalNightlifeGrantCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalNightlifeGrantCreateResponse2,
    InternalNightlifeGrantCreateError,
    Options<InternalNightlifeGrantCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalNightlifeGrantCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
